(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["FlussonicMsePlayer"] = factory();
	else
		root["FlussonicMsePlayer"] = factory();
})(this, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 909:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = Worker_fn;
var _inline = _interopRequireDefault(__webpack_require__(512));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function Worker_fn() {
  return (0, _inline["default"])("/******/ (() => { // webpackBootstrap\n(function () {\n  let statsURL = null;\n  let sendTime = 60000;\n  let jsonTable = {};\n  let sendingInterval = null;\n\n  self.addEventListener(\n    'message',\n    function (e) {\n      let data = e.data;\n      //Get command parameter to identify operation\n      const { command, commandObj } = data;\n      switch (command) {\n        case 'start':\n          statsURL = commandObj\n            .replace(/ws:/, 'http:')\n            .replace(/wss:/, 'https:')\n            .replace(/mse_ld/, 'sessions');\n          start();\n          break;\n        case 'time':\n          correctSendTime(commandObj);\n          break;\n        case 'stop':\n          stop();\n          break;\n        case 'add':\n          addToTable(commandObj);\n          break;\n        default:\n          break;\n      }\n    },\n    false\n  );\n\n  function correctSendTime(time) {\n    sendTime = time;\n  }\n\n  function start() {\n    sendingInterval = this.setInterval(() => {\n      post();\n    }, sendTime);\n  }\n\n  function stop() {\n    post();\n    clearInterval(sendingInterval);\n  }\n\n  function addToTable(data) {\n    jsonTable = { ...jsonTable, ...data };\n\n    if (data.event && data.event === 'play_stop') {\n      stop();\n    }\n  }\n\n  // function roughSizeOfObject(object) {\n  //   let objectList = [];\n  //   let stack = [object];\n  //   let bytes = 0;\n\n  //   while (stack.length) {\n  //     let value = stack.pop();\n\n  //     if (typeof value === 'boolean') {\n  //       bytes += 4;\n  //     } else if (typeof value === 'string') {\n  //       bytes += value.length * 2;\n  //     } else if (typeof value === 'number') {\n  //       bytes += 8;\n  //     } else if (typeof value === 'object' && objectList.indexOf(value) === -1) {\n  //       objectList.push(value);\n\n  //       for (let i in value) {\n  //         stack.push(value[i]);\n  //       }\n  //     }\n  //   }\n  //   return bytes;\n  // }\n\n  function post() {\n    if (!jsonTable.started_at) {\n      return;\n    }\n\n    const { source_id } = jsonTable;\n    const newUrl = statsURL.replace(/sessions/, `sessions/${source_id ? `${source_id}` : ''}`);\n    fetch(newUrl, {\n      headers: {\n        Accept: 'application/json',\n        'Content-Type': 'application/json',\n      },\n      method: 'PUT',\n      body: JSON.stringify(jsonTable),\n    });\n  }\n})();\n\n/******/ })()\n;", "Worker", undefined, __webpack_require__.p + "stats.worker.js");
}
module.exports = exports.default;

/***/ }),

/***/ 220:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = Worker_fn;
var _inline = _interopRequireDefault(__webpack_require__(512));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function Worker_fn() {
  return (0, _inline["default"])("/******/ (() => { // webpackBootstrap\n(function () {\n  //Define WebSocket and protocol variables\n  let websocket = null;\n  let mustStop = false;\n\n  //Receive message from WebSocketController\n  self.addEventListener(\n    'message',\n    function (e) {\n      let data = e.data;\n      //Get command parameter to identify operation\n      let command = data.command;\n\n      if (command === 'start') {\n        //Establish WebSocket connection\n        start(data.commandObj);\n      } else if (command === 'disconnect') {\n        //Terminate WebSocket connection\n        disconnect();\n      } else if (command === 'send') {\n        sendOMMmessage(data.commandObj);\n      }\n    },\n    false\n  );\n\n  /* -----------------  Application events functions  ----------------- */\n\n  //Establish WebSocket connection\n  function start(wsURL) {\n    websocket = new WebSocket(wsURL);\n    websocket.binaryType = 'arraybuffer';\n    websocket.onopen = onOpen;\n    websocket.onmessage = onMessage;\n    websocket.onerror = onError;\n    websocket.onclose = onClose;\n  }\n\n  function disconnect() {\n    if (websocket) {\n      websocket.close();\n    }\n    mustStop = true;\n    const disconnect_response = {\n      command: 'disconnect',\n      msg: 'Disconnected',\n    };\n    self.postMessage(disconnect_response);\n  }\n\n  //Send message to ADS WebSocket\n  function sendOMMmessage(commandObj) {\n    websocket.send(commandObj);\n  }\n\n  /* -----------------  WS events  ----------------- */\n\n  //Establish WebSocket connection success\n  function onOpen() {\n    const onOpen_response = {\n      command: 'connect',\n      msg: 'Connected',\n    };\n    self.postMessage(onOpen_response);\n  }\n\n  //Receives incoming message from WebSocket\n  function onMessage(event) {\n    const rawData = event.data;\n    const isDataAB = rawData instanceof ArrayBuffer;\n    const parsedData = !isDataAB ? JSON.parse(rawData) : void 0;\n    self.postMessage({ rawData, parsedData, isDataAB });\n  }\n\n  function onError(event) {\n    const onError_response = {\n      command: 'error',\n      msg: JSON.stringify(event),\n    };\n    self.postMessage(onError_response);\n  }\n\n  function onClose(e) {\n    if (mustStop) {\n      return;\n    }\n    const { code, reason } = e;\n    const onClose_response = {\n      command: 'close',\n      data: { code, reason },\n    };\n    self.postMessage(onClose_response);\n  }\n})();\n\n/******/ })()\n;", "Worker", undefined, __webpack_require__.p + "ws.worker.js");
}
module.exports = exports.default;

/***/ }),

/***/ 813:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _MsePlayer = _interopRequireDefault(__webpack_require__(624));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _MsePlayer["default"];
module.exports = exports.default;

/***/ }),

/***/ 708:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _mseUtils = __webpack_require__(203);
var _logger = __webpack_require__(216);
var _common = __webpack_require__(435);
var _events = __webpack_require__(339);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var BUFFER_MODE_SEQUENCE = 'segments'; // segments
// const BUFFER_MODE_SEQUENCE = 'sequence'; // segments
var BuffersController = exports["default"] = /*#__PURE__*/function () {
  function BuffersController() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, BuffersController);
    _logger.logger.log('create BuffersController');
    this.media = opts.media;
    this.init(opts);
    this.doArrayBuffer = _mseUtils.doArrayBuffer.bind(this);
    this.maybeAppend = this.maybeAppend.bind(this);
    this.onSBUpdateEnd = this.onSBUpdateEnd.bind(this);
    this.onAudioSBUpdateEnd = this.onAudioSBUpdateEnd.bind(this);
  }
  return _createClass(BuffersController, [{
    key: "init",
    value: function init() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.flushRange = [];
      this.appended = 0;
      this.mediaSource = opts.mediaSource;
      // this.segments = []
      this.segmentsVideo = [];
      this.segmentsAudio = [];
      this.sourceBuffer = {};
      // this.audioBufferSize = 0;
      // this.videoBufferSize = 0;
      this.totalBytesCollected = 0;
    }
  }, {
    key: "setMediaSource",
    value: function setMediaSource(ms) {
      this.mediaSource = ms;
    }
  }, {
    key: "createSourceBuffers",
    value: function createSourceBuffers(data) {
      var _this = this;
      var sb = this.sourceBuffer;
      data.tracks.forEach(function (s) {
        var isVideo = s.content === _common.VIDEO;
        var mimeType = isVideo ? 'video/mp4; codecs="avc1.4d401f"' : 'audio/mp4; codecs="mp4a.40.2"';
        if (s.mime_type) {
          mimeType = s.mime_type;
        }
        sb[s.content] = _this.mediaSource.addSourceBuffer(mimeType);
        sb[s.content].mode = BUFFER_MODE_SEQUENCE;
        // sb[s.content].timestampOffset = 0.25;
        var buffer = sb[s.content];
        if (isVideo) {
          buffer.addEventListener(_events.BUFFER_UPDATE_END, _this.onSBUpdateEnd);
        } else {
          buffer.addEventListener(_events.BUFFER_UPDATE_END, _this.onAudioSBUpdateEnd);
        }
      });
    }
  }, {
    key: "onSBUpdateEnd",
    value: function onSBUpdateEnd() {
      // if (this._needsFlush) {
      //   logger.log('flushing buffer');
      //   this.doFlush();
      // }

      if (this._needsEos) {
        this.checkEos();
      }
      if (!this._needsFlush && this.segmentsVideo.length) {
        var buffer = this.sourceBuffer.video;
        if (buffer) {
          if (buffer.updating) {
            return;
          }
          var segment = this.segmentsVideo[0];
          buffer.appendBuffer(segment.data);
          this.segmentsVideo.shift();
          this.videoBufferSize = this.videoBufferSize - segment.data.byteLength;
          this.appended++;
        }
      }
    }
  }, {
    key: "onAudioSBUpdateEnd",
    value: function onAudioSBUpdateEnd() {
      // if (this._needsFlush) {
      //   logger.log('flushing buffer');
      //   this.doFlush();
      // }

      if (this._needsEos) {
        this.checkEos();
      }
      if (!this._needsFlush && this.segmentsAudio.length) {
        var buffer = this.sourceBuffer.audio;
        if (buffer) {
          if (buffer.updating) {
            return;
          }
          var segment = this.segmentsAudio[0];
          buffer.appendBuffer(segment.data);
          this.segmentsAudio.shift();
          // this.audioBufferSize = this.audioBufferSize - segment.data.byteLength;
          this.appended++;
        }
      }
    }
  }, {
    key: "createTracks",
    value: function createTracks(tracks) {
      var _this2 = this;
      tracks.forEach(function (track) {
        var view = (0, _mseUtils.base64ToArrayBuffer)(track.payload);
        var segment = {
          type: _this2.getTypeBytrackId(track.id),
          isInit: true,
          data: view
        };
        _this2.maybeAppend(segment);
      });
    }
  }, {
    key: "maybeAppend",
    value: function maybeAppend(segment) {
      if (this._needsFlush) {
        // this.segments.unshift(segment)
        return;
      }
      if (!this.media || this.media.error) {
        if (segment.type === 'audio') {
          this.segmentsAudio = [];
        } else {
          this.segmentsVideo = [];
        }
        _logger.logger.error('trying to append although a media error occured, flush segment and abort');
        this.media.error && _logger.logger.error('Error code:', this.media.error);
        return;
      }
      var buffer = this.sourceBuffer[segment.type];
      if (buffer) {
        if (buffer.updating) {
          // this.segments.unshift(segment)
          return;
        }
        buffer.appendBuffer(segment.data);
        if (segment.type === 'audio') {
          this.segmentsAudio.shift();
        } else {
          this.segmentsVideo.shift();
        }
        this.appended++;
      }
    }
  }, {
    key: "setTracksByType",
    value: function setTracksByType(data) {
      var _this3 = this;
      var type = data.tracks ? 'tracks' : 'streams';
      if (data[type].length === 1) {
        this.audioTrackId = null;
      }
      data[type].forEach(function (s, index) {
        _this3[s.content === _common.VIDEO ? 'videoTrackId' : 'audioTrackId'] = {
          index: index,
          id: s.id
        };
      });
    }
  }, {
    key: "getTypeBytrackId",
    value: function getTypeBytrackId(id) {
      if (!this.audioTrackId) {
        return _common.VIDEO;
      }
      return this.audioTrackId.id === id ? _common.AUDIO : _common.VIDEO;
    }
  }, {
    key: "procArrayBuffer",
    value: function procArrayBuffer(rawData) {
      var segment = this.rawDataToSegmnet(rawData);
      if (segment.type === 'audio') {
        this.segmentsAudio.push(segment);
        // this.audioBufferSize = this.audioBufferSize + segment.data.byteLength;
      } else {
        this.segmentsVideo.push(segment);
        // this.videoBufferSize = this.videoBufferSize + segment.data.byteLength;
      }
      this.totalBytesCollected = this.totalBytesCollected + segment.data.byteLength;
      this.doArrayBuffer(segment);
      if (this.sourceBuffer) {
        if (this.sourceBuffer.video && !this.sourceBuffer.video.updating) {
          this.onSBUpdateEnd();
        }
        if (this.audioTrackId) {
          if (this.sourceBuffer.audio && !this.sourceBuffer.audio.updating) {
            this.onAudioSBUpdateEnd();
          }
        }
      }
    }
  }, {
    key: "seek",
    value: function seek() {
      for (var k in this.sourceBuffer) {
        this.sourceBuffer[k].abort();
        this.sourceBuffer[k].mode = BUFFER_MODE_SEQUENCE;
        // this.sourceBuffer[k].timestampOffset = this.sourceBuffer[k].timestampOffset - 0.2;
      }

      // this.videoBufferSize = 0
      // this.audioBufferSize = 0
      // this.segmentsVideo = []
      // this.segmentsAudio = []
    }
  }, {
    key: "isBuffered",
    value: function isBuffered() {
      var appended = 0;
      var sourceBuffer = this.sourceBuffer;
      for (var type in sourceBuffer) {
        appended += sourceBuffer[type].buffered.length;
      }
      return appended > 0;
    }
  }, {
    key: "doFlush",
    value: function doFlush() {
      // loop through all buffer ranges to flush
      while (this.flushRange.length) {
        var range = this.flushRange[0];
        // flushBuffer will abort any buffer append in progress and flush Audio/Video Buffer
        if (this.flushBuffer(range.start, range.end, range.type)) {
          // range flushed, remove from flush array
          this.flushRange.shift();
          this.flushBufferCounter = 0;
        } else {
          this._needsFlush = true;
          // avoid looping, wait for SB update end to retrigger a flush
          return;
        }
      }
      if (this.flushRange.length === 0) {
        // everything flushed
        this._needsFlush = false;

        // let's recompute this.appended, which is used to avoid flush looping
        var appended = 0;
        var sourceBuffer = this.sourceBuffer;
        try {
          for (var type in sourceBuffer) {
            appended += sourceBuffer[type].buffered.length;
          }
        } catch (error) {
          // error could be thrown while accessing buffered, in case sourcebuffer has already been removed from MediaSource
          // this is harmess at this stage, catch this to avoid reporting an internal exception
          _logger.logger.error('error while accessing sourceBuffer.buffered');
        }
        this.appended = appended;
        this._setTracksFlag = false;
      }
    }

    // /*
    //   flush specified buffered range,
    //   return true once range has been flushed.
    //   as sourceBuffer.remove() is asynchronous, flushBuffer will be retriggered on sourceBuffer update end
    // */
  }, {
    key: "flushBuffer",
    value: function flushBuffer(startOffset, endOffset, typeIn) {
      var sb,
        i,
        bufStart,
        bufEnd,
        flushStart,
        flushEnd,
        sourceBuffer = this.sourceBuffer;
      if (Object.keys(sourceBuffer).length) {
        _logger.logger.log("flushBuffer,pos/start/end: ".concat(this.media.currentTime.toFixed(3), "/").concat(startOffset, "/").concat(endOffset));
        // safeguard to avoid infinite looping : don't try to flush more than the nb of appended segments
        if (this.flushBufferCounter < this.appended) {
          for (var type in sourceBuffer) {
            // check if sourcebuffer type is defined (typeIn): if yes, let's only flush this one
            // if no, let's flush all sourcebuffers
            if (typeIn && type !== typeIn) {
              continue;
            }
            sb = sourceBuffer[type];
            // we are going to flush buffer, mark source buffer as 'not ended'
            sb.ended = false;
            if (!sb.updating) {
              try {
                for (i = 0; i < sb.buffered.length; i++) {
                  bufStart = sb.buffered.start(i);
                  bufEnd = sb.buffered.end(i);
                  // workaround firefox not able to properly flush multiple buffered range.
                  if (navigator.userAgent.toLowerCase().indexOf('firefox') !== -1 && endOffset === Number.POSITIVE_INFINITY) {
                    flushStart = startOffset;
                    flushEnd = endOffset;
                  } else {
                    flushStart = Math.max(bufStart, startOffset);
                    flushEnd = Math.min(bufEnd, endOffset);
                  }
                  /* sometimes sourcebuffer.remove() does not flush
                     the exact expected time range.
                     to avoid rounding issues/infinite loop,
                     only flush buffer range of length greater than 500ms.
                  */
                  if (Math.min(flushEnd, bufEnd) - flushStart > 0.5) {
                    this.flushBufferCounter++;
                    _logger.logger.log("flush ".concat(type, " [").concat(flushStart, ",").concat(flushEnd, "], of [").concat(bufStart, ",").concat(bufEnd, "], pos:").concat(this.media.currentTime));
                    sb.remove(flushStart, flushEnd);
                    return false;
                  }
                }
              } catch (e) {
                _logger.logger.warn('exception while accessing sourcebuffer, it might have been removed from MediaSource');
              }
            } else {
              // logger.log('abort ' + type + ' append in progress');
              // this will abort any appending in progress
              // sb.abort();
              _logger.logger.warn('cannot flush, sb updating in progress');
              return false;
            }
          }
        } else {
          _logger.logger.warn('abort flushing too many retries');
        }
        _logger.logger.log('buffer flushed');
      }
      // everything flushed !
      return true;
    }
  }, {
    key: "rawDataToSegmnet",
    value: function rawDataToSegmnet(rawData) {
      var view = new Uint8Array(rawData);
      var trackId = (0, _mseUtils.getTrackId)(view);
      var trackType = this.getTypeBytrackId(trackId);
      return {
        type: trackType,
        data: view
      };
    }

    // on BUFFER_EOS mark matching sourcebuffer(s) as ended and trigger checkEos()
  }, {
    key: "onBufferEos",
    value: function onBufferEos() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var sb = this.sourceBuffer;
      var dataType = data.type;
      for (var type in sb) {
        if (!dataType || type === dataType) {
          if (!sb[type].ended) {
            sb[type].ended = true;
            _logger.logger.log("".concat(type, " sourceBuffer now EOS"));
          }
        }
      }
      this.checkEos();
    }

    // if all source buffers are marked as ended, signal endOfStream() to MediaSource.
  }, {
    key: "checkEos",
    value: function checkEos() {
      var sb = this.sourceBuffer,
        mediaSource = this.mediaSource;
      if (!mediaSource || mediaSource.readyState !== 'open') {
        this._needsEos = false;
        return;
      }
      for (var type in sb) {
        var sbobj = sb[type];
        if (!sbobj.ended) {
          return;
        }
        if (sbobj.updating) {
          this._needsEos = true;
          return;
        }
      }
      _logger.logger.log('all media data available, signal endOfStream() to MediaSource and stop loading fragment');
      // Notify the media element that it now has all of the media data
      try {
        mediaSource.endOfStream();
      } catch (e) {
        _logger.logger.warn('exception while calling mediaSource.endOfStream()');
      }
      this._needsEos = false;
    }
  }, {
    key: "addSourceBuffer",
    value: function addSourceBuffer() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'audio';
      var sb = this.sourceBuffer;
      var mimeType = type === 'video' ? 'video/mp4; codecs="avc1.4d401f"' : 'audio/mp4; codecs="mp4a.40.2"';
      sb[type] = this.mediaSource.addSourceBuffer(mimeType);
      sb[type].mode = BUFFER_MODE_SEQUENCE;
      // sb[type].timestampOffset = 0.25;
      var buffer = sb[type];
      if (type === 'video') {
        buffer.addEventListener(_events.BUFFER_UPDATE_END, this.onSBUpdateEnd);
      } else {
        buffer.addEventListener(_events.BUFFER_UPDATE_END, this.onAudioSBUpdateEnd);
      }
    }
  }, {
    key: "removeSourceBuffer",
    value: function removeSourceBuffer() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'audio';
      var buffer = this.sourceBuffer[type];
      if (type === 'audio') {
        buffer.removeEventListener(_events.BUFFER_UPDATE_END, this.onAudioSBUpdateEnd);
      } else {
        buffer.removeEventListener(_events.BUFFER_UPDATE_END, this.onSBUpdateEnd);
      }
      this.mediaSource.removeSourceBuffer(buffer);
      delete this.sourceBuffer[type];
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.init();
    }
  }]);
}();
module.exports = exports.default;

/***/ }),

/***/ 97:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
exports.getWSURL = getWSURL;
var _parseurl = _interopRequireDefault(__webpack_require__(189));
var _wsWorker = _interopRequireDefault(__webpack_require__(220));
var _logger = __webpack_require__(216);
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // import EVENTS from '../enums/events'
var WS_COMMAND_SEEK_LIVE = '';
var WS_COMMAND_SEEK = 'play_from=';
var LIVE = 'live';
var WebSocketController = exports["default"] = /*#__PURE__*/function () {
  function WebSocketController(opts) {
    _classCallCheck(this, WebSocketController);
    this.opts = opts;
    this.init();
    this.onwso = this.open.bind(this);
    this.onwsm = this.handleReceiveMessage.bind(this);
    this.onwse = this.handleError.bind(this);
    this.onwsc = this.onWSClose.bind(this);
  }
  return _createClass(WebSocketController, [{
    key: "init",
    value: function init() {
      if (this.wsWorker) {
        delete this.wsWorker;
      }
      this.opened = false;
      this.connectionPromise = void 0;
      clearTimeout(this.reconnect);
      this.reconnect = void 0;
      if (window.Worker) {
        this.wsWorker = new _wsWorker["default"]();
        this.wsWorker.onmessage = this.onWorkerMessage.bind(this);
      }
    }
  }, {
    key: "onWorkerMessage",
    value: function onWorkerMessage(message) {
      var data = message.data;
      var command = data.command;
      switch (command) {
        case 'connect':
          this.open();
          break;
        case 'close':
          this.onWSClose(data);
          break;
        case 'error':
          this.handleError(data);
          break;
        default:
          this.handleReceiveMessage(data);
      }
    }
  }, {
    key: "start",
    value: function start(url, time) {
      var _this = this;
      var videoTrack = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var audioTack = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      /**
       * if call ws.send command immediately after start
       * it causes to error message like "ws still in connection status"
       * #6809
       */
      this.connectionPromise = new Promise(function (res, rej) {
        _this.socketURL = {
          url: url,
          time: time,
          videoTrack: videoTrack,
          audioTack: audioTack
        };
        var wsURL = getWSURL(url, time, videoTrack, audioTack);
        _this.wsWorker.postMessage({
          command: 'start',
          commandObj: wsURL
        });
        _this._openingResolve = res;
        // TODO: to think cases when ws can fall
        _this._openingReject = rej;
      });
      return this.connectionPromise;
    }
  }, {
    key: "open",
    value: function open() {
      if (this.opened) return;
      this.opened = true;
      this.paused = true;
      this._openingResolve(); // #6809
    }
  }, {
    key: "send",
    value: function send(cmd) {
      this.wsWorker.postMessage({
        command: 'send',
        commandObj: cmd
      });
    }
  }, {
    key: "resume",
    value: function resume() {
      clearTimeout(this.reconnect);
      _logger.logger.log('ws: send resume');
      // if (this.websocket.readyState === 0) {
      //   return setTimeout(() => this.resume(), 500)
      // } else {
      this.send('resume');
      this.paused = false;
      // }
    }
  }, {
    key: "pause",
    value: function pause() {
      _logger.logger.log('ws: send pause');
      /**
       * 0 (CONNECTING) The connection is not yet open.
       * 1 (OPEN) The connection is open and ready to communicate.
       * 2 (CLOSING) The connection is in the process of closing.
       * 3 (CLOSED) The connection is closed or couldn't be opened.
       */
      // if (this.websocket.readyState === 1) {
      this.send('pause');
      this.paused = true;
      // }
    }
  }, {
    key: "seek",
    value: function seek(utc) {
      var commandStr = utc === LIVE ? WS_COMMAND_SEEK_LIVE : WS_COMMAND_SEEK;
      _logger.logger.log("".concat(commandStr).concat(utc));
      this.send("".concat(commandStr).concat(utc));
    }
  }, {
    key: "setTracks",
    value: function setTracks(videoTrack) {
      var audioTrack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.send("set_tracks=".concat(videoTrack).concat(audioTrack));
    }
  }, {
    key: "sendStats",
    value: function sendStats(data) {
      // console.log(data);
      var encoded = JSON.stringify(data);
      this.send(encoded);
    }
  }, {
    key: "handleReceiveMessage",
    value: function handleReceiveMessage(e) {
      this.opts.message(e);
    }
  }, {
    key: "handleError",
    value: function handleError() {
      if (this.opts.error) {
        var _this$opts;
        (_this$opts = this.opts).error.apply(_this$opts, arguments);
      }
    }
  }, {
    key: "onWSClose",
    value: function onWSClose(event) {
      var _this2 = this;
      _logger.logger.log('WebSocket lost connection with code ', event.code + ' and reason: ' + event.reason); // например, "убит" процесс сервера
      if (this.opts.error) {
        this.opts.error({
          error: 'WebSocket lost connection',
          err: "WebSocket lost connection with code ".concat(event.code, " and reason: ").concat(event.reason),
          code: event.code
        });
      }
      if (this.opts.wsReconnect) {
        if (event.wasClean && event.code !== 1000 && event.code !== 1006) {
          _logger.logger.log('Clean websocket stop');
          this.destroy();
        } else {
          var _this$socketURL = this.socketURL,
            url = _this$socketURL.url,
            videoTrack = _this$socketURL.videoTrack,
            audioTack = _this$socketURL.audioTack;
          this.reconnect = setTimeout(function () {
            _this2.start(url, videoTrack, audioTack).then(function () {
              clearTimeout(_this2.reconnect);
              return;
            })["catch"](function () {
              _this2.destroy();
              return;
            });
          }, 5000);
        }
      }
      if (this.opts.closed) {
        this.opts.closed(event);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.wsWorker.postMessage({
        command: 'disconnect'
      });
      clearTimeout(this.reconnect);
      this.reconnect = void 0;
      this.init();
    }
  }]);
}(); // TODO
function getWSURL(url, utc, videoTrack, audioTrack) {
  // TODO: then use @param time it prevent to wrong data from ws(trackID view[47] for example is 100)
  // const time = utc
  utc = LIVE;
  var time = utc;
  if (!time && !videoTrack && !audioTrack) {
    return url;
  }
  var parsedUrl = (0, _parseurl["default"])({
    url: url
  });
  var othersParams = '';
  if (parsedUrl.query) {
    var currentParamsKeysValues = parsedUrl.query.split('&').map(function (keyValue) {
      return keyValue.split('=');
    });
    othersParams = currentParamsKeysValues.filter(function (p) {
      return p[0] !== 'from' && p[0] !== 'tracks';
    }).map(function (kv) {
      return kv.join('=');
    }).join('&');
    _logger.logger.log(othersParams);
  }
  var cleanUrl = "".concat(parsedUrl.protocol, "//").concat(parsedUrl.host).concat(parsedUrl.pathname, "?");
  var tracksExists = !!videoTrack || !!audioTrack;
  var ampFrom = tracksExists && !!time && time !== LIVE ? '&' : '';
  var fromQuery = utc === LIVE ? '' : "from=".concat(Math.floor(time));
  if (!utc) {
    fromQuery = '';
  }
  var resultUrl = "".concat(cleanUrl).concat(tracksExists ? "tracks=".concat(videoTrack).concat(audioTrack) : '') + "".concat(ampFrom).concat(fromQuery) + "".concat((tracksExists || !!time && time !== LIVE) && !!othersParams ? '&' : '').concat(othersParams);
  return resultUrl;
}

/***/ }),

/***/ 435:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.VIDEO = exports.AUDIO = void 0;
var VIDEO = exports.VIDEO = 'video';
var AUDIO = exports.AUDIO = 'audio';

/***/ }),

/***/ 339:
/***/ ((module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var EVENTS = {
  // MediaSource
  MEDIA_SOURCE_SOURCE_OPEN: 'sourceopen',
  MEDIA_SOURCE_SOURCE_ENDED: 'sourceended',
  MEDIA_SOURCE_SOURCE_CLOSE: 'sourceclose',
  // HTMLMediaElement
  MEDIA_ELEMENT_PLAY: 'play',
  MEDIA_ELEMENT_PAUSE: 'pause',
  MEDIA_ELEMENT_PROGRESS: 'progress',
  MEDIA_ELEMENT_EMPTIED: 'emptied',
  MEDIA_ELEMENT_SUSPEND: 'suspend',
  MEDIA_ELEMENT_STALLED: 'stalled',
  MEDIA_ELEMENT_WAITING: 'waiting',
  MEDIA_ELEMENT_RATECHANGE: 'ratechange',
  MEDIA_ELEMENT_PLAYING: 'playing',
  // WebSocket
  WS_OPEN: 'open',
  WS_MESSAGE: 'message',
  WS_ERROR: 'error',
  WS_CLOSE: 'close',
  // Buffer
  BUFFER_UPDATE_END: 'updateend',
  BUFFER_ERROR: 'onerror',
  BUFFER_ABORT: 'onabort'
};
var _default = exports["default"] = EVENTS;
module.exports = exports.default;

/***/ }),

/***/ 534:
/***/ ((module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var MSG = {
  NOT_HTML_MEDIA_ELEMENT: 'media should be an HTMLMediaElement instance'
};
var _default = exports["default"] = MSG;
module.exports = exports.default;

/***/ }),

/***/ 52:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.MSE_MEDIA_SEGMENT = exports.MSE_INIT_SEGMENT = exports.EVENT_SEGMENT = void 0;
var EVENT_SEGMENT = exports.EVENT_SEGMENT = 'event';
var MSE_INIT_SEGMENT = exports.MSE_INIT_SEGMENT = 'mse_init_segment';
var MSE_MEDIA_SEGMENT = exports.MSE_MEDIA_SEGMENT = 'mse_media_segment';

/***/ }),

/***/ 624:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _ws = _interopRequireDefault(__webpack_require__(97));
var _buffers = _interopRequireDefault(__webpack_require__(708));
var _statsWorker = _interopRequireDefault(__webpack_require__(909));
var mseUtils = _interopRequireWildcard(__webpack_require__(203));
var _logger = __webpack_require__(216);
var _segments = __webpack_require__(52);
var _common = __webpack_require__(435);
var _events = _interopRequireDefault(__webpack_require__(339));
var _messages = _interopRequireDefault(__webpack_require__(534));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // import MediaSourceController from '../controllers/mediaSource'
var WS_EVENT_PAUSED = 'paused';
var WS_EVENT_RESUMED = 'resumed';
var WS_EVENT_SEEKED = 'seeked';
var WS_EVENT_SWITCHED_TO_LIVE = 'switched_to_live';
var WS_EVENT_EOS = 'recordings_ended';
var WS_EVENT_NO_LIVE = 'stream_unavailable';
var WS_EVENT_TRACKS_SWITCHED = 'tracks_switched';
var WS_TRY_RECONNECT = false;
var WS_PREFER_HIGH_QUALITY = false;
var TYPE_CONTENT_VIDEO = _common.VIDEO;
var TYPE_CONTENT_AUDIO = _common.AUDIO;
var DEFAULT_ERRORS_BEFORE_STOP = 1;
var DEFAULT_UPDATE = 500;
var DEFAULT_CONNECTIONS_RETRIES = 0;
var DEFAULT_RETRY_MUTED = false;
var MAX_BUFFER_DELAY = 2;
var DEFAULT_STATS_SEND = true;
var MSEPlayer = exports["default"] = /*#__PURE__*/function () {
  /**
   *
   * @param media HTMLMediaElement
   * @param urlStream
   * @param opts
   */

  function MSEPlayer(media, urlStream) {
    var _this = this;
    var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, MSEPlayer);
    if (opts.debug) {
      (0, _logger.enableLogs)(true);
      window.humanTime = mseUtils.humanTime;
    }
    _logger.logger.info('[mse-player]:', MSEPlayer.version);
    this.opts = opts || {};
    this.media = media;
    this.url = urlStream;
    this.firstStart = true;
    this.opts.progressUpdateTime = this.opts.progressUpdateTime || DEFAULT_UPDATE;
    this.opts.errorsBeforeStop = this.opts.errorsBeforeStop ? this.opts.errorsBeforeStop : DEFAULT_ERRORS_BEFORE_STOP;
    if (typeof this.opts.errorsBeforeStop !== 'number' || isNaN(this.opts.errorsBeforeStop)) {
      throw new Error('invalid errorsBeforeStop param, should be number');
    }
    this.opts.connectionRetries = this.opts.connectionRetries || DEFAULT_CONNECTIONS_RETRIES;
    if (typeof this.opts.connectionRetries !== 'number' || isNaN(this.opts.connectionRetries)) {
      throw new Error('invalid connectionRetries param, should be number');
    }
    this.opts.wsReconnect = this.opts.wsReconnect ? this.opts.wsReconnect : WS_TRY_RECONNECT;
    if (typeof this.opts.wsReconnect !== 'boolean') {
      throw new Error('invalid wsReconnect param, should be boolean');
    }
    this.opts.preferHQ = this.opts.preferHQ ? this.opts.preferHQ : WS_PREFER_HIGH_QUALITY;
    if (typeof this.opts.preferHQ !== 'boolean') {
      throw new Error('invalid preferHQ param, should be boolean');
    }
    this.retry = 0;
    this.retryConnectionTimer;
    this.opts.retryMuted = this.opts.retryMuted ? this.opts.retryMuted : DEFAULT_RETRY_MUTED;
    if (typeof this.opts.retryMuted !== 'boolean') {
      throw new Error('invalid retryMuted param, should be boolean');
    }
    this.opts.maxBufferDelay = this.opts.maxBufferDelay ? this.opts.maxBufferDelay : MAX_BUFFER_DELAY;
    var ua = navigator.userAgent;
    if (/Edge/.test(ua) || /trident.*rv:1\d/i.test(ua)) {
      this.opts.maxBufferDelay = 10; // very slow buffers in Edge
    }
    if (typeof this.opts.maxBufferDelay !== 'number') {
      throw new Error('invalid maxBufferDelay param, should be number');
    }
    if (this.opts.videoQuality) {
      if (typeof this.opts.videoQuality !== 'string') {
        throw new Error('invalid videoQuality param, should be string');
      }
      if (this.opts.videoQuality !== 'highest' && this.opts.videoQuality !== 'lowest') {
        throw new Error('invalid videoQuality param, should be highest or lowest');
      }
    }
    try {
      this.Sentry = __webpack_require__(Object(function webpackMissingModule() { var e = new Error("Cannot find module '@sentry/browser'"); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
    } catch (e) {
      this.noSentry = true;
    }
    this.opts.sentryConfig = this.opts.sentryConfig ? this.opts.sentryConfig : '';
    if (typeof this.opts.sentryConfig !== 'string') {
      throw new Error('invalid sentryConfig param, should be string');
    }
    if (this.opts.sentryConfig.length && !this.noSentry) {
      this.Sentry.init({
        dsn: this.opts.sentryConfig,
        environment: "production" || 0,
        release: 'Mse Player@' + MSEPlayer.version
      });
      document.onerror = function (err) {
        _this.Sentry.captureException(err);
      };
    }
    if (typeof this.opts.maxBufferDelay !== 'number') {
      throw new Error('invalid maxBufferDelay param, should be number');
    }

    // Stats block start
    this.opts.statsSendEnable = 'statsSendEnable' in this.opts && typeof this.opts.statsSendEnable === 'boolean' && this.opts.statsSendEnable === false ? false : DEFAULT_STATS_SEND;
    if (window.Worker && this.opts.statsSendEnable) {
      this.statsWorker = new _statsWorker["default"]();
      this.statsWorker.onmessage = this.onStatsWorkerMessage.bind(this);
      if (this.opts.statsSendTime) {
        if (typeof this.opts.statsSendTime !== 'number') {
          throw new Error('invalid statsSendTime param, should be number');
        }
        this.statsWorker.postMessage({
          command: 'time',
          commandObj: this.opts.statsSendTime * 1000
        });
      }
      this.statsWorker.postMessage({
        command: 'start',
        commandObj: this.url
      });
      this.statsWorkerStarted = true;
    }
    this.resetStats = function () {
      _this.playerStatsObject = {
        proto: 'mseld',
        user_agent: navigator.userAgent,
        bytes: 0,
        // player info
        application: {
          application_name: 'mseld_player',
          application_version: MSEPlayer.version,
          // counts
          stall_count: 0,
          pause_count: 0,
          error_count: 0,
          reconnect_count: 0,
          bitrate_change_count: 0,
          // durations
          live_duration: 0,
          stall_duration: 0,
          pause_duration: 0,
          // frames stats
          total_video_frames: 0,
          dropped_video_frames: 0,
          corrupted_video_frames: 0
        }
      };
      _this.addStat(_this.playerStatsObject);
      if (!_this.statsWorkerStarted && _this.opts.statsSendEnable) {
        _this.statsWorker.postMessage({
          command: 'start',
          commandObj: _this.url
        });
        _this.statsWorkerStarted = true;
      }
    };
    // Stats block end

    this.onProgress = opts && opts.onProgress;
    if (opts && opts.onDisconnect) {
      this.onDisconnect = opts && opts.onDisconnect;
    } else {
      this.onDisconnect = function (status) {
        _logger.logger.log('[websocket status]:', status);
      };
    }
    this.onMediaInfo = opts && opts.onMediaInfo;
    this.onError = opts && opts.onError;
    this.onEventCallback = opts && opts.onEvent;
    this.onAutoplay = opts && opts.onAutoplay;
    this.onMuted = opts && opts.onMuted;
    this.onStats = opts && opts.onStats;
    this.onMessage = opts && opts.onMessage;
    this.onPause = opts && opts.onPause;
    this.onResume = opts && opts.onResume;
    if (media instanceof HTMLMediaElement) {
      // iOS autoplay with no fullscreen fix
      media.WebKitPlaysInline = true;
      media.controls = false;
    }
    this.ws = new _ws["default"]({
      message: this.dispatchMessage.bind(this),
      closed: this.onDisconnect.bind(this),
      error: this.onError,
      wsReconnect: this.opts.wsReconnect
    });

    /* SourceBuffers Controller */
    this.sb = new _buffers["default"]({
      media: media
    });
    this.messageTime = Date.now();
    this.init();
  }
  return _createClass(MSEPlayer, [{
    key: "play",
    value: function play(videoTrack, audioTrack) {
      var _this2 = this;
      _logger.logger.log("[mse-player]: play(".concat(videoTrack, ", ").concat(audioTrack, ")"));
      if (this.playing) {
        _logger.logger.log('MSE is already playing');
        return;
      }
      if (this.ws && this.ws.websocket && !this._pause) {
        _logger.logger.log('[mse-player]: websocket already opened');
        return;
      }
      return new Promise(function (resolve, reject) {
        if (_this2.mediaSource && _this2.mediaSource.readyState === 'open') {
          _this2._play();
          return;
        }
        if (!_this2.mediaSource) {
          _this2.onAttachMedia({
            media: _this2.media
          }).then(function () {
            _this2.onsoa = _this2._play.bind(_this2, videoTrack, audioTrack);
            _this2.sb.setMediaSource(_this2.mediaSource);
            _this2.mediaSource.addEventListener(_events["default"].MEDIA_SOURCE_SOURCE_OPEN, _this2.onsoa);
            _logger.logger.warn('mediaSource did not create');
            _this2.resolveThenMediaSourceOpen = _this2.resolveThenMediaSourceOpen ? _this2.resolveThenMediaSourceOpen : resolve;
            _this2.rejectThenMediaSourceOpen = _this2.rejectThenMediaSourceOpen ? _this2.rejectThenMediaSourceOpen : reject;
            return;
          });
        }

        // deferring execution
        if (_this2.mediaSource && _this2.mediaSource.readyState !== 'open') {
          _logger.logger.warn('readyState is not "open", it\'s currently ', _this2.mediaSource.readyState);
          _this2.shouldPlay = true;
          _this2.resolveThenMediaSourceOpen = _this2.resolveThenMediaSourceOpen ? _this2.resolveThenMediaSourceOpen : resolve;
          _this2.rejectThenMediaSourceOpen = _this2.rejectThenMediaSourceOpen ? _this2.rejectThenMediaSourceOpen : reject;
          return;
        }
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this3 = this;
      if (this.playPromise) {
        this.onEvent({
          key: Date.now(),
          data: {
            event: 'play_stop'
          }
        });
        this.playerStatsObject.closed_at = Date.now();
        this.addStat({
          closed_at: this.playerStatsObject.closed_at
        });
        if (this.opts.statsSendEnable) {
          this.statsWorkerStarted = false;
        }
        this.playPromise["catch"](/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (_this3.resetTimer) {
                  clearTimeout(_this3.resetTimer);
                  _this3.resetTimer = void 0;
                }
                if (!_this3._stop) {
                  _context.next = 4;
                  break;
                }
                _logger.logger.log('[mse-player]: already stopped');
                return _context.abrupt("return");
              case 4:
                _context.next = 6;
                return _this3.onMediaDetaching();
              case 6:
              case "end":
                return _context.stop();
            }
          }, _callee);
        })))["finally"](/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (_this3.resetTimer) {
                  clearTimeout(_this3.resetTimer);
                  _this3.resetTimer = void 0;
                }
                if (!_this3._stop) {
                  _context2.next = 4;
                  break;
                }
                _logger.logger.log('[mse-player]: already stopped');
                return _context2.abrupt("return");
              case 4:
                _context2.next = 6;
                return _this3.onMediaDetaching();
              case 6:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        })));
      } else {
        if (this.resetTimer) {
          clearTimeout(this.resetTimer);
          this.resetTimer = void 0;
        }
        this.endProgressTimer();
        _logger.logger.log('[mse-player]: no playPromise exists, nothing to stop');
      }
      this.firstStart = true;
      delete this.uuid;
    }
  }, {
    key: "pause",
    value: function pause() {
      if (!canPause.bind(this)()) {
        return _logger.logger.log('[mse:playback] can not do pause');
      }
      var binded = _pause.bind(this);
      // https://developers.google.com/web/updates/2017/06/play-request-was-interrupted
      this.playPromise.then(binded, binded)["catch"](binded, binded);
      function _pause() {
        this.ws.pause();
        this.media.pause();
        this._pause = true;
        this.playing = false;
        this.addPlayerStat('pause_count');
        this.pauseStarted = Date.now();
        if (this.onPause) {
          try {
            this.onPause();
          } catch (e) {
            _logger.logger.error('Error ' + e.name + ':' + e.message + '\n' + e.stack);
          }
        }
      }
      function canPause() {
        if (this._pause || !this.playing || !this.media || !this.ws || !this.mediaSource || this.mediaSource && this.mediaSource.readyState !== 'open' || !this.playPromise) {
          return false;
        }
        return true;
      }
    }
  }, {
    key: "restart",
    value: function restart() {
      var fullRestart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var from = fullRestart ? undefined : this.sb.lastLoadedUTC;
      this.playing = false;
      this.ws.destroy();
      this.ws.init();
      this.ws.start(this.url, from, this.videoTrack, this.audioTrack);
      this.addPlayerStat('reconnect_count');
      this.onEndStalling();
    }
  }, {
    key: "retryConnection",
    value: function retryConnection() {
      var _this4 = this;
      var videoTrack = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var audioTrack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (this.retry >= this.opts.connectionRetries) {
        clearInterval(this.retryConnectionTimer);
        return;
      }
      _logger.logger.log('%cconnectionRetry:', 'background: orange;', "Retrying ".concat(this.retry + 1));
      this.mediaSource = void 0;
      this.init();
      this.ws.destroy();
      this.sb.destroy();
      this.play(videoTrack, audioTrack).then(function () {
        _this4.onEndStalling();
      });
      this.retry = this.retry + 1;
    }
  }, {
    key: "setTracks",
    value: function setTracks(data) {
      var _this5 = this;
      var tracks = data;
      if (!this.mediaInfo) {
        _logger.logger.warn('Media info did not loaded. Should try after onMediaInfo triggered or inside.');
        return;
      }
      if (tracks === 'lowest') {
        tracks = this.autoTrackSelection(false);
      } else if (tracks === 'highest') {
        tracks = this.autoTrackSelection(true);
      } else if (!Array.isArray(tracks)) {
        _logger.logger.error('tracks should be an Array instance: ["v1", "a1"]');
        return;
      }
      if (!this.playing) {
        this.pendingTracks = tracks;
        return;
      }
      var videoTracksType = this.mediaInfo.streams ? 'streams' : 'tracks';
      var videoTracksStr = tracks.filter(function (id) {
        var stream = _this5.mediaInfo[videoTracksType].find(function (s) {
          return id === s['track_id'];
        });
        return !!stream && stream.content === TYPE_CONTENT_VIDEO;
      }).join('');
      var audioTracksStr = tracks.filter(function (id) {
        var stream = _this5.mediaInfo[videoTracksType].find(function (s) {
          return id === s['track_id'];
        });
        if (stream) {
          // if (stream.bitrate && stream.bitrate === 0) {
          //   return null
          // }
          return !!stream && stream.content === TYPE_CONTENT_AUDIO;
        } else {
          return null;
        }
      }).join('');
      if (!audioTracksStr.length && !videoTracksStr.length) {
        _logger.logger.warn('No such stream tracks! Setting to default parameters');
        var videoTracks = this.getVideoTracks();
        var audioTracks = this.getAudioTracks();
        if (audioTracks.length) {
          audioTracksStr = audioTracks[0].track_id;
        } else {
          _logger.logger.warn('No audio tracks');
        }
        if (videoTracks.length) {
          // Добавить адаптивный выбор видео дорожки?
          videoTracksStr = videoTracks[0].track_id;
        } else {
          _logger.logger.warn('No video tracks');
        }
      }
      if (!audioTracksStr.length) {
        if (this.sb.sourceBuffer.audio) {
          this.sb.removeSourceBuffer();
        }
        this.media.muted = true;
        _logger.logger.warn('No audio tracks');
      }
      if (videoTracksStr.length && audioTracksStr.length && this.mediaSource.sourceBuffers.length <= 1) {
        this.stop();
        this.videoTrack = videoTracksStr;
        this.audioTrack = audioTracksStr;
        if (this._stop) {
          this.play(videoTracksStr, audioTracksStr);
        } else {
          setTimeout(function () {
            _this5.play(videoTracksStr, audioTracksStr);
          }, 0);
        }
        return;
      }
      this.onStartStalling();
      this.ws.setTracks(videoTracksStr, audioTracksStr);
      this.addPlayerStat('bitrate_change_count');
      this.videoTrack = videoTracksStr;
      this.audioTrack = audioTracksStr;
      // ?
      this._setTracksFlag = true;
      this.waitForInitFrame = true;
    }
  }, {
    key: "autoTrackSelection",
    value: function autoTrackSelection(bestestBest) {
      if (!this.mediaInfo) {
        _logger.logger.warn('Media info did not loaded. Should try after onMediaInfo triggered or inside.');
        return;
      }
      var videoTracks = this.getVideoTracks();
      var audioTracks = this.getAudioTracks();
      var resultVideo, resultAudio;
      if (bestestBest) {
        var bestVideo, videoParam;
        if (videoTracks.length === 1) {
          resultVideo = videoTracks[0].track_id;
        } else {
          if (videoTracks[0].bitrate) {
            videoParam = 'bitrate';
          } else if (videoTracks[0].pixel_width) {
            videoParam = 'pixel_width';
          }
          bestVideo = videoTracks[0][videoParam];
          resultVideo = videoTracks[0].track_id;
          videoTracks.forEach(function (track) {
            if (track[videoParam] > bestVideo) {
              bestVideo = track[videoParam];
              resultVideo = track.track_id;
            }
          });
        }
        if (audioTracks.length) {
          if (audioTracks.length === 1) {
            resultAudio = audioTracks[0].track_id;
          } else {
            // let bestAudio = audioTracks[0].sample_rate;
            resultAudio = audioTracks[0].track_id;
            audioTracks.forEach(function (track) {
              if (track.sample_rate > bestVideo) {
                // bestAudio = track.sample_rate;
                resultAudio = track.track_id;
              }
            });
          }
        }
      } else {
        var worstVideo, _videoParam;
        if (videoTracks.length === 1) {
          resultVideo = videoTracks[0].track_id;
        } else {
          if (videoTracks[0].bitrate) {
            _videoParam = 'bitrate';
          } else if (videoTracks[0].pixel_width) {
            _videoParam = 'pixel_width';
          }
          worstVideo = videoTracks[0][_videoParam];
          resultVideo = videoTracks[0].track_id;
          videoTracks.forEach(function (track) {
            if (track[_videoParam] < worstVideo) {
              worstVideo = track[_videoParam];
              resultVideo = track.track_id;
            }
          });
        }
        if (audioTracks.length) {
          var worstAudio;
          if (audioTracks.length === 1) {
            resultAudio = audioTracks[0].track_id;
          } else {
            worstAudio = audioTracks[0].sample_rate;
            resultAudio = audioTracks[0].track_id;
            audioTracks.forEach(function (track) {
              if (track.sample_rate < worstAudio) {
                worstAudio = track.sample_rate;
                resultAudio = track.track_id;
              }
            });
          }
        }
      }
      var resultData = [];
      if (resultVideo && resultVideo.length) {
        resultData.push(resultVideo);
      }
      if (resultAudio && resultAudio.length) {
        resultData.push(resultAudio);
      }
      return resultData;
    }

    /**
     *
     *  Private members
     *
     */
  }, {
    key: "_play",
    value: function _play(videoTrack, audioTrack) {
      var _this6 = this;
      if (this.opts.debug) {
        console.trace('_play', videoTrack, audioTrack);
      }
      return new Promise(function (resolve, reject) {
        _logger.logger.log('_play', videoTrack, audioTrack);
        if (_this6.playing) {
          var message = '[mse-player] _play: terminate because already has been playing';
          _logger.logger.log(message);
          return resolve({
            message: message
          });
        }
        if (_this6._pause) {
          // should invoke play method of video in onClick scope
          // further logic are duplicated at checkVideoProgress
          // https://github.com/jwplayer/jwplayer/issues/2421#issuecomment-333130812

          if (_this6.ws && _this6.ws.opened === false) {
            _logger.logger.log('WebSocket Closed, trying to restart it');
            _this6._pause = false;
            _this6.restart(true);
            return;
          } else {
            _logger.logger.log('WebSocket is in opened state, resuming');
            _this6._pause = false;
            _this6._resume(); // ws
            if (_this6.pauseStarted) {
              var application = _this6.playerStatsObject.application;
              if (application) {
                var pause_duration = application.pause_duration;
                pause_duration += Date.now() - _this6.pauseStarted;
                _this6.addPlayerStat('pause_duration', false, pause_duration);
                delete _this6.pauseStarted;
              }
            }
          }
          _this6.playPromise = _this6.media.play();
          _logger.logger.log('_play: terminate because _paused and should resume');
          return _this6.playPromise;
        }
        _this6.resetStats();
        _this6.playerStatsObject.opened_at = Date.now();
        _this6.uuid = _this6.generateUUID();
        _this6.addStat({
          opened_at: _this6.playerStatsObject.opened_at,
          id: _this6.uuid
        });
        _this6.videoTrack = videoTrack;
        _this6.audioTrack = audioTrack;
        _this6._pause = false;
        var ifApple = function ifApple() {
          var iDevices = ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod', 'Safari'];
          if (navigator.platform) {
            while (iDevices.length) {
              if (navigator.platform === iDevices.pop()) {
                return true;
              }
            }
          }
          return false;
        };

        // for autoplay on interaction
        var autoPlayFunc = new Promise(function (resolve, reject) {
          if (_this6.media.autoplay && _this6.media.muted !== true && !_this6.opts.retryMuted) {
            if (_this6.onAutoplay && !ifApple()) {
              _this6.onAutoplay(function () {
                _this6.media.muted = false;
                return resolve();
              });
            } else {
              _this6.media.muted = true;
              return resolve();
            }
          } else {
            return resolve();
          }
          reject();
        });
        autoPlayFunc.then(function () {
          if (_this6.liveError) return;
          _this6.ws.start(_this6.url, _this6.playTime, _this6.videoTrack, _this6.audioTrack).then(function () {
            // https://developers.google.com/web/updates/2017/06/play-request-was-interrupted
            _this6.playPromise = _this6.media.play();
            _this6.playPromise.then(function () {
              _this6.onStartStalling(); // switch off at progress checker
              _this6.startProgressTimer();
              if (_this6.resolveThenMediaSourceOpen) {
                _this6._stop = false;
                _this6.resolveThenMediaSourceOpen();
                _this6.resolveThenMediaSourceOpen = void 0;
                _this6.rejectThenMediaSourceOpen = void 0;
                clearInterval(_this6.retryConnectionTimer);
                _this6.retry = 0;
              }
              _this6.onEvent({
                key: Date.now(),
                data: {
                  event: 'play_started'
                }
              });
            })["catch"](function (err) {
              _logger.logger.log('playPromise rejection.', err);
              // if error, this.ws.connectionPromise can be undefined
              if (_this6.ws.connectionPromise) {
                _this6.ws.connectionPromise.then(function () {
                  return _this6.ws.destroy();
                }); // #6694
              }
              if (_this6.opts.retryMuted && _this6.media.muted == false) {
                if (_this6.onMuted) {
                  _this6.onMuted();
                }
                _this6.media.muted = true;
                _this6._play(/*from, */videoTrack, audioTrack);
              }
              _this6.onPlayerError({
                error: 'play_promise_reject',
                err: err
              });
              if (_this6.rejectThenMediaSourceOpen) {
                _this6.rejectThenMediaSourceOpen();
                _this6.resolveThenMediaSourceOpen = void 0;
                _this6.rejectThenMediaSourceOpen = void 0;
              }
              if (!_this6.opts.retryMuted) {
                _this6.stop();
              }
            });
            return _this6.playPromise;
          });
        });
      });
    }
  }, {
    key: "init",
    value: function init() {
      var fromStop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this._pause = false;
      this.playing = false;
      this.liveError = false;
      // flag to pending execution(true)
      this.shouldPlay = false;
      // store to execute pended method play
      // this.playTime = void 0
      this.audioTrack = '';
      this.videoTrack = '';
      this.endProgressTimer();
      if (!fromStop) {
        this.onEvent({
          key: Date.now(),
          data: {
            event: 'play_init',
            userInfo: window.navigator.userAgent,
            playerInfo: "MSEPlayer".concat(MSEPlayer.version ? "@".concat(MSEPlayer.version) : '')
          }
        });
      }
    }
  }, {
    key: "_resume",
    value: function _resume() {
      this.ws.resume();
      this.onEvent({
        key: Date.now(),
        data: {
          event: 'play_websocket_resume'
        }
      });
    }
  }, {
    key: "onMediaDetaching",
    value: function onMediaDetaching() {
      var _this7 = this;
      if (this.stopRunning) {
        _logger.logger.warn('stop is running.');
        return;
      }
      this.stopRunning = true;
      // workaround pending playPromise state
      // TODO: how to be with pending internal statuses
      // https://developers.google.com/web/updates/2017/06/play-request-was-interrupted
      // const bindedMD =
      this.handlerMediaDetaching.bind(this);
      if (this.playPromise) {
        // there are two cases:
        // resolved/rejected
        // both required to shutdown ws, mediasources and etc.
        this.playPromise["catch"](function () {
          return _this7.handlerMediaDetaching();
        })["finally"](function () {
          return _this7.handlerMediaDetaching();
        });
      } else {
        return this.handlerMediaDetaching();
      }
    }
  }, {
    key: "handlerMediaDetaching",
    value: function handlerMediaDetaching() {
      var _this8 = this;
      _logger.logger.info('media source detaching');
      return new Promise(function (resolve, reject) {
        // destroy media source and detach from media element
        _this8.removeMediaSource();
        if (!_this8.media) {
          return reject('no media to detach');
        }
        _this8.removeListeners();
        _this8.oncvp = null;
        _this8.mediaSource = null;
        _this8.init(true);
        _this8.ws.destroy();
        _this8.sb.destroy();
        _this8.media.onemptied = function () {
          _logger.logger.log('[mse-player]: media emptied');
          _this8.stopRunning = false;
          _this8._stop = true;
          delete _this8.playPromise;
          return resolve();
        };
      });
    }
  }, {
    key: "removeMediaSource",
    value: function removeMediaSource() {
      var _this9 = this;
      var ms = this.mediaSource;
      if (ms) {
        if (ms.readyState === 'open') {
          try {
            // endOfStream could trigger exception if any sourcebuffer is in updating state
            // we don't really care about checking sourcebuffer state here,
            // as we are anyway detaching the MediaSource
            // let's just avoid this exception to propagate
            ms.endOfStream();
          } catch (err) {
            _logger.logger.warn("onMediaDetaching:".concat(err.message, " while calling endOfStream"));
          }
        }
        ms.removeEventListener(_events["default"].MEDIA_SOURCE_SOURCE_OPEN, this.onmso);
        ms.removeEventListener(_events["default"].MEDIA_SOURCE_SOURCE_ENDED, this.onmse);
        ms.removeEventListener(_events["default"].MEDIA_SOURCE_SOURCE_CLOSE, this.onmsc);
        this.onmso = null;
        this.onmse = null;
        this.onmsc = null;
      }

      // Detach properly the MediaSource from the HTMLMediaElement as
      // suggested in https://github.com/w3c/media-source/issues/53.
      // URL.revokeObjectURL(this.media.src)
      var close = function close() {
        _this9.media.src = '';
        _this9.media.load();
        if (_this9.resetTimer) {
          clearTimeout(_this9.resetTimer);
          _this9.resetTimer = void 0;
        }
      };
      this.playPromise && this.playPromise.then(function () {
        close();
      })["catch"](function () {
        close();
      });
    }
  }, {
    key: "onMediaElementEmptied",
    value: function onMediaElementEmptied(resolve) {
      if (this.onMediaElementEmptied && this.media) {
        this.media.removeEventListener(_events["default"].MEDIA_ELEMENT_EMPTIED, this.onMediaElementEmptied);
        this._onmee = void 0;
      }
      return resolve;
    }
  }, {
    key: "onAttachMedia",
    value: function onAttachMedia(data) {
      var _this10 = this;
      this.media = data.media;
      var media = this.media;
      if (!(media instanceof HTMLMediaElement)) {
        throw new Error(_messages["default"].NOT_HTML_MEDIA_ELEMENT);
      }
      if (media) {
        // setup the media source
        var ms = this.mediaSource = new MediaSource();
        // Media Source listeners
        this.onmse = this.onMediaSourceEnded.bind(this);
        this.onmsc = this.onMediaSourceClose.bind(this);
        ms.addEventListener(_events["default"].MEDIA_SOURCE_SOURCE_ENDED, this.onmse);
        ms.addEventListener(_events["default"].MEDIA_SOURCE_SOURCE_CLOSE, this.onmsc);
        // link video and media Source
        media.src = URL.createObjectURL(ms);
        this.eventLog = function (event) {
          if (_this10.onEvent) {
            _this10.onEvent(event);
          }
        };
        this.addListeners();
        if (this.liveError) {
          this.player = void 0;
          return;
        }
        return new Promise(function (resolve) {
          _this10.onmso = _this10.onMediaSourceOpen.bind(_this10, resolve);
          ms.addEventListener(_events["default"].MEDIA_SOURCE_SOURCE_OPEN, _this10.onmso);
        });
      }
    }
  }, {
    key: "onMediaSourceOpen",
    value: function onMediaSourceOpen(resolve) {
      resolve();
      var mediaSource = this.mediaSource;
      if (mediaSource) {
        // once received, don't listen anymore to sourceopen event
        mediaSource.removeEventListener(_events["default"].MEDIA_SOURCE_SOURCE_OPEN, this.onmso);
      }
      URL.revokeObjectURL(this.media.src);

      // play was called but stoped and was pend(1.readyState is not open)
      // and time is come to execute it
      if (this.shouldPlay) {
        this.shouldPlay = false;
        _logger.logger.info("readyState now is ".concat(this.mediaSource.readyState, ", and will be played"),
        // this.playTime,
        this.videoTrack, this.audioTrack);
        this._play(this.videoTrack, this.audioTrack);
      }
    }
  }, {
    key: "onDisconnect",
    value: function onDisconnect(event) {
      this.onEvent({
        key: Date.now(),
        data: {
          event: 'play_diconnected'
        }
      });
      if (this.opts.onDisconnect) {
        this.opts.onDisconnect(event);
      }
    }

    // canStartUnmuted() {
    //   if (!this.playing && this.shouldPlay) {
    //     this.shouldPlay = false
    //     this._play(this.playTime, this.audioTrack, this.videoTrack).then(() => {
    //       this.media.muted = false
    //       window.removeEventListener('click', this.canStartUnmuted)
    //       window.removeEventListener('touchstart', this.canStartUnmuted)
    //     })
    //   }
    // }
  }, {
    key: "dispatchMessage",
    value: function dispatchMessage(data) {
      var _this11 = this;
      if (this.stopRunning) {
        return;
      }
      if (!this.playerStatsObject.first_byte_at) {
        this.playerStatsObject.first_byte_at = Date.now();
        this.addStat({
          first_byte_at: this.playerStatsObject.first_byte_at
        });
      }
      var rawData = data.rawData,
        parsedData = data.parsedData,
        isDataAB = data.isDataAB;
      mseUtils.logDM(isDataAB, parsedData);
      try {
        // ArrayBuffer data
        if (isDataAB) {
          // wait for MSE_INIT_SEGMENT
          if (this.waitForInitFrame) {
            return _logger.logger.log('old frames');
          }
          this.sb.procArrayBuffer(rawData);
        }

        /*
         * EVENTS
         */
        if (parsedData && parsedData.type === _segments.EVENT_SEGMENT) {
          var eventType = parsedData[_segments.EVENT_SEGMENT];
          _logger.logger.log("%c ".concat(parsedData.type, " ").concat(parsedData.type === 'event' ? parsedData.event : 'mse_init_segment'), 'background: aquamarine;', parsedData);
          switch (eventType) {
            case WS_EVENT_RESUMED:
              if (this._pause && !this.playing) {
                // wait for "progress" event, for shift currentTime and start playing
                this.onStartStalling();
              }
              this.onResume && this.onResume();
              break;
            case WS_EVENT_PAUSED:
              break;
            case WS_EVENT_SEEKED:
            case WS_EVENT_SWITCHED_TO_LIVE:
              this.seekValue = void 0;
              if (this.opts.onSeeked) {
                try {
                  this.opts.onSeeked();
                } catch (err) {
                  _logger.logger.error(err);
                }
              }
              break;
            case WS_EVENT_EOS:
              this._eos = true;
              this.sb.onBufferEos();
              break;
            // if live source is unavailability
            case WS_EVENT_NO_LIVE:
              if ('static' in parsedData && parsedData["static"] == false) {
                _logger.logger.info('Stream is on on demand mode, waiting for init segment');
                this.onStartStalling();
              } else {
                _logger.logger.warn('do playPromise reject with error');
                if (this.ws.connectionPromise) {
                  this.ws.connectionPromise.then(function () {
                    return _this11.ws.pause();
                  }); // #6694
                }
                if (!this.liveError) {
                  this.onPlayerError({
                    error: 'playPromise reject - stream unavaible'
                  });
                  this.liveError = true;
                  this.shouldPlay = false;
                  if (this.resetTimer) {
                    clearTimeout(this.resetTimer);
                    this.resetTimer = void 0;
                  }
                  return;
                }
                if (this.rejectThenMediaSourceOpen) {
                  this.rejectThenMediaSourceOpen();
                  this.resolveThenMediaSourceOpen = void 0;
                  this.rejectThenMediaSourceOpen = void 0;
                }
                // this.playPromise = Promise.reject('stream unavaible');
                this.mediaSource.endOfStream();
              }
              break;
            case WS_EVENT_TRACKS_SWITCHED:
              break;
            default:
              if (this.opts.onEvent) {
                this.opts.onEvent({
                  error: 'unhandled_event',
                  event: eventType
                });
              }
              _logger.logger.warn('unknown type of event', eventType);
          }
          return;
        }
        // MSE_INIT_SEGMENT
        if (parsedData && parsedData.type === _segments.MSE_INIT_SEGMENT) {
          return this.procInitSegment(rawData);
        }
      } catch (err) {
        mseUtils.showDispatchError.bind(this)(err);
        try {
          if (this.media.error) {
            this.onPlayerError({
              error: 'Media error',
              mediaError: this.media.error
            });
            this.stop();
          } else {
            if (this.mediaInfo && this.mediaInfo.activeStreams) {
              var activeStreams = this.mediaInfo.activeStreams;
              this.setTracks([activeStreams.video ? activeStreams.video : '', activeStreams.audio ? activeStreams.audio : '']);
            }
          }
        } catch (err) {
          this.ws.pause();
        }
      }
    }
  }, {
    key: "procInitSegment",
    value: function procInitSegment(rawData) {
      var _this12 = this;
      var data = JSON.parse(rawData);
      if (data.type !== _segments.MSE_INIT_SEGMENT) {
        return _logger.logger.warn("type is not ".concat(_segments.MSE_INIT_SEGMENT));
      }
      if (this.waitForInitFrame) {
        this.waitForInitFrame = false;
      }
      if (this.resetTimer) {
        clearTimeout(this.resetTimer);
        this.resetTimer = void 0;
      }
      if (this.sb.isBuffered()) {
        // this.media.pause()
        // this.previouslyPaused = false
        // this._setTracksFlag = true
        // this.immediateSwitch = true
        // const startOffset = 0
        // const endOffset = Infinity
        // // TODO: should invoke remove method of SourceBuffer's
        // this.sb.flushRange.push({start: startOffset, end: endOffset, type: void 0})
        // // attempt flush immediately
        // this.sb.flushBufferCounter = 0
        this.sb.doFlush();
        this.sb.seek();
      }

      // calc this.audioTrackId this.videoTrackId
      this.sb.setTracksByType(data);
      var metadata = _objectSpread(_objectSpread({}, data.metadata), {}, {
        tracks: data.metadata.streams ? data.metadata.streams : data.metadata.tracks,
        streams: data.metadata.streams ? data.metadata.streams : data.metadata.tracks
      });
      var streams = data.metadata.streams;
      if (data.metadata.tracks) {
        streams = data.metadata.tracks;
      }
      var activeStreams = {};
      var videoIndex = this.sb.videoTrackId && this.sb.videoTrackId.id - 1;
      if (streams[videoIndex] && streams[videoIndex]['track_id']) {
        if (streams[videoIndex].bitrate && streams[videoIndex].bitrate === 0 || streams[videoIndex].height === 0 || streams[videoIndex].width === 0) {
          this.onPlayerError({
            error: 'Video track error'
          });
          return;
        }
        activeStreams.video = streams[videoIndex]['track_id'];
      }
      var audioIndex = this.sb.audioTrackId && this.sb.audioTrackId.id - 1;
      if (audioIndex) {
        if (streams[audioIndex] && streams[audioIndex]['track_id']) {
          if (streams[audioIndex].bitrate && streams[audioIndex].bitrate === 0) {
            this.onPlayerError({
              error: 'Audio track error'
            });
            var idToDelete;
            data.tracks.forEach(function (item, index) {
              if (item.id === _this12.sb.audioTrackId.id) {
                idToDelete = index;
              }
            });
            data.tracks.splice(idToDelete, 1);
            if (this.sb.sourceBuffer.audio) {
              this.mediaSource.removeSourceBuffer(this.sb.sourceBuffer.audio);
              // this.sb.audioTrackId = void 0
              delete this.sb.sourceBuffer.audio;
            }
          } else {
            activeStreams.audio = streams[audioIndex]['track_id'];
          }
        }
      }
      var activeInfo = _objectSpread(_objectSpread({}, metadata), {}, {
        activeStreams: activeStreams,
        version: MSEPlayer.version
      });
      this.playerStatsObject.source_id = data.session_id;
      this.addStat({
        source_id: this.playerStatsObject.source_id
      });
      this.doMediaInfo(activeInfo);
      _logger.logger.log('%cprocInitSegment:', 'background: lightpink;', data);
      this.onEvent({
        key: Date.now(),
        data: _objectSpread({
          event: 'play_metadata'
        }, activeInfo)
      });
      if (this.mediaSource && !this.mediaSource.sourceBuffers.length) {
        this.sb.setMediaSource(this.mediaSource);
        this.sb.createSourceBuffers(data);
      }
      if (!this.liveError) {
        this.sb.createTracks(data.tracks);
      }
      if (this.opts.videoQuality && this.firstStart) {
        this.firstStart = false;
        var selectedTracks;
        if (this.opts.videoQuality === 'lowest') {
          selectedTracks = this.autoTrackSelection(false);
        } else if (this.opts.videoQuality === 'highest') {
          selectedTracks = this.autoTrackSelection(true);
        }
        this.ws.setTracks(selectedTracks[0] || '', selectedTracks[1] || '');
      }
      if (this.opts.preferHQ) {
        _logger.logger.info('[MSE]: preferHQ option is depricated. Use videoQuality(lowest/highest) instead');
      }
      this.ws.resume();
    }
  }, {
    key: "doMediaInfo",
    value: function doMediaInfo(metadata) {
      _logger.logger.log('%cmediaInfo:', 'background: orange;', metadata);
      this.mediaInfo = metadata;
      if (this.onMediaInfo) {
        try {
          this.onMediaInfo(metadata);
        } catch (e) {
          _logger.logger.error(mseUtils.errorMsg(e));
        }
      }
    }
  }, {
    key: "getVideoTracks",
    value: function getVideoTracks() {
      if (!this.mediaInfo) {
        return;
      }
      var videoTracksType = this.mediaInfo.streams ? 'streams' : 'tracks';
      return this.mediaInfo[videoTracksType].filter(function (s) {
        return s.content === TYPE_CONTENT_VIDEO;
      });
    }
  }, {
    key: "getAudioTracks",
    value: function getAudioTracks() {
      if (!this.mediaInfo) {
        return;
      }
      var videoTracksType = this.mediaInfo.streams ? 'streams' : 'tracks';
      return this.mediaInfo[videoTracksType].filter(function (s) {
        return s.content === TYPE_CONTENT_AUDIO;
      });
    }

    /**
     * on immediate level switch end, after new fragment has been buffered:
     * - nudge video decoder by slightly adjusting video currentTime (if currentTime buffered)
     * - resume the playback if needed
     */
  }, {
    key: "immediateLevelSwitchEnd",
    value: function immediateLevelSwitchEnd() {
      var _this13 = this;
      var media = this.media;
      if (media && media.buffered.length) {
        this.immediateSwitch = false;
        // if (BufferHelper.isBuffered(media, media.currentTime)) {
        // only nudge if currentTime is buffered
        // media.currentTime -= 0.0001;
        // }
        if (!this.previouslyPaused) {
          this.playPromise = media.play();
          this.playPromise.then(function () {
            _this13._pause = false;
            _this13.playing = true;
          });
        }
      }
    }
  }, {
    key: "onStartStalling",
    value: function onStartStalling() {
      var _this14 = this;
      if (this._pause) return;
      if (!this.resetTimer) {
        this.resetTimer = setTimeout(function () {
          _this14.restart();
        }, 60000);
      }
      if (this._stalling) return;
      if (this.opts.onStartStalling) {
        this.opts.onStartStalling();
      }
      this._stalling = true;
      _logger.logger.log('onStartStalling');
      if (this.playerStatsObject.started_at) {
        this.addPlayerStat('stall_count');
        this.startStallingTime = Date.now();
      }
      this.onEvent({
        key: Date.now(),
        data: {
          event: 'play_stalled'
        }
      });
    }
  }, {
    key: "onEndStalling",
    value: function onEndStalling() {
      if (!this._stalling) return;
      if (this.opts.onEndStalling) {
        this.opts.onEndStalling();
      }
      this._stalling = false;
      _logger.logger.log('onEndStalling');
      clearTimeout(this.resetTimer);
      this.resetTimer = void 0;
      if (this.startStallingTime) {
        var application = this.playerStatsObject.application;
        if (application) {
          var stall_duration = application.stall_duration;
          stall_duration += Date.now() - this.startStallingTime;
          this.startStallingTime = null;
          this.addPlayerStat('stall_duration', false, stall_duration);
        }
      }
      this.onEvent({
        key: Date.now(),
        data: {
          event: 'play_resumed'
        }
      });
    }
  }, {
    key: "startProgressTimer",
    value: function startProgressTimer() {
      this.timer = setInterval(this.onTimer.bind(this), this.opts.progressUpdateTime);
    }
  }, {
    key: "endProgressTimer",
    value: function endProgressTimer() {
      clearInterval(this.timer);
      this.timer = void 0;
    }
  }, {
    key: "onTimer",
    value: function onTimer() {
      if (this._eos) {
        return _logger.logger.log('nothing to play');
      }

      // #TODO explain
      if (this.immediateSwitch) {
        this.immediateLevelSwitchEnd();
      }
      if (this.sb.lastLoadedUTC === this.utcPrev) {
        // logger.log('%cloaded utc is not change', 'background: orange;', this.sb.lastLoadedUTC, this.utcPrev, this._stalling)
        return;
      }
      if (this._stalling) {
        // logger.log('%cStalling flag is true', 'background: lightred;')
        return;
      }
      this.utcPrev = this.sb.lastLoadedUTC;
      if (!this.onProgress) {
        return;
      }
      try {
        this.onProgress(this.sb.lastLoadedUTC);
      } catch (e) {
        _logger.logger.error(mseUtils.errorMsg(e));
      }
    }
  }, {
    key: "onMediaSourceEnded",
    value: function onMediaSourceEnded() {
      _logger.logger.log('media source ended');
      try {
        if (this.opts.onEOS) {
          this.opts.onEOS();
        }
      } catch (err) {
        _logger.logger.error('error while proccessing onEOS');
      }
    }
  }, {
    key: "onMediaSourceClose",
    value: function onMediaSourceClose() {
      _logger.logger.log('media source closed');
    }
  }, {
    key: "onConnectionRetry",
    value: function onConnectionRetry() {
      var _this15 = this;
      if (!this.retryConnectionTimer && !this._stop) {
        if (this.retry < this.opts.connectionRetries) {
          this.retryConnectionTimer = setInterval(function () {
            return _this15.retryConnection();
          }, 5000);
        }
      } else if (this.retry >= this.opts.connectionRetries) {
        clearInterval(this.retryConnectionTimer);
      }
    }
  }, {
    key: "loadingIndication",
    value: function loadingIndication(event) {
      var type = event.type;
      if (type === 'playing') {
        this.playing = true;
        this.onEndStalling();
        if (!this.playerStatsObject.started_at) {
          this.playerStatsObject.started_at = Date.now();
          this.addStat({
            started_at: this.playerStatsObject.started_at
          });
        }
      } else if (type === 'waiting') {
        this.playing = false;
        this.onStartStalling();
      }
    }
  }, {
    key: "onEvent",
    value: function onEvent(event) {
      if (this.onEventCallback) {
        this.onEventCallback(event);
      }
    }
  }, {
    key: "onPlayerError",
    value: function onPlayerError(errorData) {
      if (this.playerStatsObject) {
        this.addPlayerStat('error_count');
      }
      this.onError && this.onError(errorData);
    }
  }, {
    key: "addListeners",
    value: function addListeners() {
      if (this.media) {
        // checkVideoProgress
        this.oncvp = mseUtils.checkVideoProgress(this.media, this).bind(this);
        this.media.addEventListener(_events["default"].MEDIA_ELEMENT_PROGRESS, this.oncvp);

        // this.media.addEventListener(EVENTS.MEDIA_ELEMENT_STALLED, this.loadingIndication.bind(this));
        // this.media.addEventListener(EVENTS.MEDIA_ELEMENT_SUSPEND, this.loadingIndication.bind(this));
        // this.media.addEventListener(EVENTS.MEDIA_ELEMENT_RATECHANGE, this.loadingIndication.bind(this));
        this.media.addEventListener(_events["default"].MEDIA_ELEMENT_PLAYING, this.loadingIndication.bind(this));
        this.media.addEventListener(_events["default"].MEDIA_ELEMENT_WAITING, this.loadingIndication.bind(this));
        // this.media.addEventListener(EVENTS.MEDIA_ELEMENT_PAUSE, this.pause.bind(this));
      }
    }
  }, {
    key: "removeListeners",
    value: function removeListeners() {
      if (this.media) {
        this.media.removeEventListener(_events["default"].MEDIA_ELEMENT_PROGRESS, this.oncvp);

        // this.media.removeEventListener(EVENTS.MEDIA_ELEMENT_STALLED, this.loadingIndication.bind(this));
        // this.media.removeEventListener(EVENTS.MEDIA_ELEMENT_SUSPEND, this.loadingIndication.bind(this));
        // this.media.removeEventListener(EVENTS.MEDIA_ELEMENT_RATECHANGE, this.loadingIndication.bind(this));
        this.media.removeEventListener(_events["default"].MEDIA_ELEMENT_PLAYING, this.loadingIndication);
        this.media.removeEventListener(_events["default"].MEDIA_ELEMENT_WAITING, this.loadingIndication);
        // this.media.removeEventListener(EVENTS.MEDIA_ELEMENT_PAUSE, this.pause)
      }
    }
  }, {
    key: "generateUUID",
    value: function generateUUID() {
      // Public Domain/MIT
      var d = new Date().getTime(); //Timestamp
      var d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0; //Time in microseconds since page-load or 0 if unsupported
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16; //random number between 0 and 16
        if (d > 0) {
          //Use timestamp until depleted
          r = (d + r) % 16 | 0;
          d = Math.floor(d / 16);
        } else {
          //Use microseconds since page-load if supported
          r = (d2 + r) % 16 | 0;
          d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
      });
    }
  }, {
    key: "addPlayerStat",
    value: function addPlayerStat(name) {
      var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var application = this.playerStatsObject.application;
      if (application) {
        if (data) {
          application[name] = Math.round(data);
        } else if (count) {
          application[name]++;
        }
        this.playerStatsObject.application = application;
        this.addStat({
          application: application
        });
      }
    }
  }, {
    key: "addStat",
    value: function addStat(data) {
      this.statsWorker && this.statsWorker.postMessage({
        command: 'add',
        commandObj: data
      });
    }
  }, {
    key: "getStats",
    value: function getStats() {
      return _objectSpread(_objectSpread({}, this.playerStatsObject), {}, {
        id: this.uuid
      });
    }
  }, {
    key: "onStatsWorkerMessage",
    value: function onStatsWorkerMessage() {
      if (!this.playerStatsObject.started_at) {
        return;
      }
      if (this.opts.statsSendEnable) {
        var _ref3 = this.playerStatsObject && this.playerStatsObject.source_id || {},
          source_id = _ref3.source_id;
        var newUrl = this.url.replace(/sessions/, "sessions/".concat(source_id ? "".concat(source_id) : ''));
        fetch(newUrl, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          method: 'PUT',
          body: JSON.stringify(this.getStats())
        });
      }
    }
  }], [{
    key: "version",
    get: function get() {
      return "24.6.1";
    }
  }, {
    key: "replaceHttpByWS",
    value: function replaceHttpByWS(url) {
      return mseUtils.replaceHttpByWS(url);
    }
  }, {
    key: "isSupported",
    value: function isSupported() {
      return mseUtils.isSupportedMSE();
    }
  }]);
}();
module.exports = exports.default;

/***/ }),

/***/ 216:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.logger = exports.enableLogs = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function noop() {}
var fakeLogger = {
  trace: noop,
  debug: noop,
  log: noop,
  warn: noop,
  info: noop,
  error: noop
};
var exportedLogger = fakeLogger;
function formatMsg(type, msg) {
  msg = '[' + type + '] > ' + msg;
  return msg;
}
function consolePrintFn(type) {
  var func = __webpack_require__.g.console[type];
  if (func) {
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if (args[0]) {
        args[0] = formatMsg(type, args[0]);
      }
      args && func.apply(__webpack_require__.g.console, args);
    };
  }
  return noop;
}
function exportLoggerFunctions(debugConfig) {
  for (var _len2 = arguments.length, functions = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    functions[_key2 - 1] = arguments[_key2];
  }
  functions.forEach(function (type) {
    exportedLogger[type] = debugConfig[type] ? debugConfig[type].bind(debugConfig) : consolePrintFn(type);
  });
}
var enableLogs = exports.enableLogs = function enableLogs(debugConfig) {
  if (debugConfig === true || _typeof(debugConfig) === 'object') {
    exportLoggerFunctions(debugConfig,
    // Remove out from list here to hard-disable a log-level
    'trace', 'debug', 'log', 'info', 'warn', 'error');
    // Some browsers don't allow to use bind on console object anyway
    // fallback to default if needed
    try {
      exportedLogger.log();
    } catch (e) {
      exportedLogger = fakeLogger;
    }
  } else {
    exportedLogger = fakeLogger;
  }
};
var logger = exports.logger = exportedLogger;

/***/ }),

/***/ 203:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.RawDataToUint8Array = RawDataToUint8Array;
exports.base64ToArrayBuffer = base64ToArrayBuffer;
exports.checkVideoProgress = void 0;
exports.debugData = debugData;
exports.doArrayBuffer = doArrayBuffer;
exports.errorMsg = void 0;
exports.getMediaSource = getMediaSource;
exports.getRealUtcFromData = getRealUtcFromData;
exports.getTrackId = getTrackId;
exports.humanTime = humanTime;
exports.isAndroid = isAndroid;
exports.isSupportedMSE = isSupportedMSE;
exports.logDM = logDM;
exports.pad2 = pad2;
exports.replaceHttpByWS = void 0;
exports.showDispatchError = showDispatchError;
var _logger = __webpack_require__(216);
function getMediaSource() {
  if (typeof window !== 'undefined') {
    return window.MediaSource || window.WebKitMediaSource;
  }
}
function isAndroid() {
  var ua = navigator.userAgent;
  return ua.indexOf('Android') !== -1;
}
function isSupportedMSE() {
  // https://bugs.chromium.org/p/chromium/issues/detail?id=539707
  if (isAndroid()) {
    return false;
  }
  var mediaSource = getMediaSource();
  var sourceBuffer = window.SourceBuffer || window.WebKitSourceBuffer;
  var isTypeSupported = mediaSource && typeof mediaSource.isTypeSupported === 'function' && mediaSource.isTypeSupported('video/mp4; codecs="avc1.4d401f,mp4a.40.2"');

  // if SourceBuffer is exposed ensure its API is valid
  // safari and old version of Chrome doe not expose SourceBuffer globally so checking SourceBuffer.prototype is impossible
  var sourceBufferValidAPI = !sourceBuffer || sourceBuffer.prototype && typeof sourceBuffer.prototype.appendBuffer === 'function' && typeof sourceBuffer.prototype.remove === 'function';
  return !!isTypeSupported && !!sourceBufferValidAPI;
}
function base64ToArrayBuffer(base64) {
  return Uint8Array.from(atob(base64), function (c) {
    return c.charCodeAt(0);
  });
}
function RawDataToUint8Array(rawData) {
  // 12,4 = mfhd;20,4 slice - segment.id;36,4 = tfhd;44,4 slice - track.id;64,4 = tfdt
  // 72,8 slice - prestime;84,4 = futc;92,8 slice - real utc;104,4 = trun
  return new Uint8Array(rawData);
}
function getTrackId(data) {
  return data[47];
}
function getRealUtcFromData(view) {
  var pts1 = view[92] << 24 | view[93] << 16 | view[94] << 8 | view[95];
  var pts2 = view[96] << 24 | view[97] << 16 | view[98] << 8 | view[99];
  var realUtc = pts1 + pts2 / 1000000;
  return realUtc;
}
function doArrayBuffer(segment) {
  if (!segment.isInit) {
    // last loaded frame's utc
    this.utc = getRealUtcFromData(segment.data);
    this.lastLoadedUTC = this.utc;
  }

  // this.maybeAppend(segment, isVideo)
}
function debugData(rawData) {
  // const view = RawDataToUint8Array(rawData)
  var view = new Uint8Array(rawData);
  var trackId = getTrackId(view);
  var utc = getRealUtcFromData(view);
  return {
    trackId: trackId,
    utc: utc,
    view: view
  };
}
var checkVideoProgress = exports.checkVideoProgress = function checkVideoProgress(media, player) {
  return function () {
    var ct = media.currentTime,
      buffered = media.buffered,
      l = media.buffered.length;
    var debounce = function debounce(func, wait, immediate) {
      var timeout;
      return function () {
        var context = this,
          args = arguments;
        var later = function later() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    };
    var removeBufferRange = function removeBufferRange(type, sb, startOffset, endOffset) {
      try {
        for (var i = 0; i < sb.buffered.length; i++) {
          var bufStart = sb.buffered.start(i);
          var bufEnd = sb.buffered.end(i);
          var removeStart = Math.max(bufStart, startOffset);
          var removeEnd = Math.min(bufEnd, endOffset);

          /* sometimes sourcebuffer.remove() does not flush
            the exact expected time range.
            to avoid rounding issues/infinite loop,
            only flush buffer range of length greater than 500ms.
          */
          if (Math.min(removeEnd, bufEnd) - removeStart > 0.5) {
            // let currentTime = 'null';
            // if (media) {
            //   currentTime = media.currentTime.toString();
            // }
            if (sb.updating) {
              return;
            }
            // logger.log(`sb remove ${type} [${removeStart},${removeEnd}], of [${bufStart},${bufEnd}], pos:${currentTime}`)
            sb.remove(removeStart, removeEnd);
            return true;
          }
        }
      } catch (error) {
        _logger.logger.warn('removeBufferRange failed', error);
      }
      return false;
    };
    if (player) {
      var sourceBuffer = player.sb.sourceBuffer;
      var bufferTypes = Object.keys(sourceBuffer);
      var targetBackBufferPosition = ct - 30;
      for (var index = bufferTypes.length - 1; index >= 0; index--) {
        var bufferType = bufferTypes[index];
        var sb = sourceBuffer[bufferType];
        if (sb) {
          var _buffered = sb.buffered;
          // when target buffer start exceeds actual buffer start
          if (_buffered.length > 0 && targetBackBufferPosition > _buffered.start(0)) {
            // remove buffer up until current time minus minimum back buffer length (removing buffer too close to current
            // time will lead to playback freezing)
            // credits for level target duration - https://github.com/videojs/http-streaming/blob/3132933b6aa99ddefab29c10447624efd6fd6e52/src/segment-loader.js#L91
            debounce(removeBufferRange(bufferType, sb, 0, targetBackBufferPosition), 100);
          }
        }
      }
    }
    if (player.media.readyState <= 2 && player.media.networkState === 2) {
      player.onStartStalling();
    } else if (player.media.readyState > 2) {
      player.onEndStalling();
    }
    if (!l) {
      return;
    }
    var endTime = buffered.end(l - 1);
    var delay = Math.abs(endTime - ct);
    // if (player._stalling) {
    //   // player.onEndStalling()
    //   // если поставлена пауза
    //   if (media.paused && player._pause && !player.playing) {
    //     media.currentTime = endTime - 0.0001
    //     player.playPromise = media.play()
    //     player.playPromise
    //       .then(() => {
    //         player._pause = false
    //         player.playing = true
    //       })
    //       .catch(() => {
    //         return
    //       })
    //   }
    // }

    if (player.playerStatsObject) {
      player.playerStatsObject.bytes = player.sb.totalBytesCollected;
      player.playerStatsObject.updated_at = Date.now();
      if (player.playing) {
        if (player.playbackSegmentStart) {
          var playerIns = player.playerStatsObject.application;
          if (playerIns) {
            var vQuality = player.media.getVideoPlaybackQuality();
            var corruptedVideoFrames = vQuality.corruptedVideoFrames,
              droppedVideoFrames = vQuality.droppedVideoFrames,
              totalVideoFrames = vQuality.totalVideoFrames;
            var live_duration = playerIns.live_duration;
            live_duration += player.playerStatsObject.updated_at - player.playbackSegmentStart;
            player.addPlayerStat('live_duration', false, live_duration);
            player.addPlayerStat('total_video_frames', false, totalVideoFrames);
            player.addPlayerStat('dropped_video_frames', false, droppedVideoFrames);
            player.addPlayerStat('corrupted_video_frames', false, corruptedVideoFrames);
          }
        }
        player.playbackSegmentStart = player.playerStatsObject.updated_at;
      }
      player.addStat({
        updated_at: player.playerStatsObject.updated_at,
        bytes: player.sb.totalBytesCollected
      });
    }
    if (delay <= player.opts.maxBufferDelay) {
      return;
    }
    _logger.logger.log('nudge', ct, '->', l ? endTime : '-', ct - endTime); //evt, )
    media.currentTime = endTime - 0.2; // (Math.abs(ct - endTime)) //
  };
};
var replaceHttpByWS = exports.replaceHttpByWS = function replaceHttpByWS(url) {
  return url.replace(/^http/, 'ws');
};
var errorMsg = exports.errorMsg = function errorMsg(e) {
  return "Error ".concat(e.name, ": ").concat(e.message, "\n").concat(e.stack);
};
function pad2(n) {
  return n <= 9 ? '0' + n : '' + n;
}
function humanTime(utcOrLive) {
  var lt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  // $FlowFixMe: string > 0 is always false
  if (!(utcOrLive > 0)) {
    return '';
  }

  // $FlowFixMe: just for flow
  var utc = utcOrLive;
  var d = new Date();
  d.setTime(utc * 1000);
  var localTime = !(lt === false);
  var h = localTime ? d.getHours() : d.getUTCHours();
  var m = localTime ? d.getMinutes() : d.getUTCMinutes();
  var s = localTime ? d.getSeconds() : d.getUTCSeconds();
  return pad2(h) + ':' + pad2(m) + ':' + pad2(s);
}
function logDM(isDataAB, parsedData) {
  if (parsedData) {
    _logger.logger.log("%c ".concat(parsedData.type, " ").concat(parsedData.type === 'event' ? parsedData.event : 'mse_init_segment'), 'background: aquamarine;', parsedData);
  }
}
var errorsCount = 0;
function showDispatchError(e) {
  var err = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if ('data' in e) {
    var rawData = e.data;
    var isDataAB = rawData instanceof ArrayBuffer;
    if (isDataAB) {
      _logger.logger.error('Data:', debugData(e.data));
    }
  }
  _logger.logger.error(errorMsg(e), err);
  if (this.media && 'error' in this.media) {
    _logger.logger.error('MediaError:', this.media.error);
  }
  errorsCount++;
  if (errorsCount >= this.opts.errorsBeforeStop) {
    errorsCount = 0;
    this.stopPromise = this.stop();
  }
  if (this.onError) {
    this.onError(err, e);
  }
}

/*
 * debug staff, after each operation you should
 * set count to 0, if you want show info about
 * ArrayBuffer frames
 */
// let count = 0

/***/ }),

/***/ 75:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(453);

var callBind = __webpack_require__(487);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),

/***/ 487:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(743);
var GetIntrinsic = __webpack_require__(453);
var setFunctionLength = __webpack_require__(897);

var $TypeError = __webpack_require__(675);
var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $defineProperty = __webpack_require__(655);
var $max = GetIntrinsic('%Math.max%');

module.exports = function callBind(originalFunction) {
	if (typeof originalFunction !== 'function') {
		throw new $TypeError('a function is required');
	}
	var func = $reflectApply(bind, $call, arguments);
	return setFunctionLength(
		func,
		1 + $max(0, originalFunction.length - (arguments.length - 1)),
		true
	);
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),

/***/ 41:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var $defineProperty = __webpack_require__(655);

var $SyntaxError = __webpack_require__(68);
var $TypeError = __webpack_require__(675);

var gopd = __webpack_require__(795);

/** @type {import('.')} */
module.exports = function defineDataProperty(
	obj,
	property,
	value
) {
	if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
		throw new $TypeError('`obj` must be an object or a function`');
	}
	if (typeof property !== 'string' && typeof property !== 'symbol') {
		throw new $TypeError('`property` must be a string or a symbol`');
	}
	if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
		throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
		throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
		throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
		throw new $TypeError('`loose`, if provided, must be a boolean');
	}

	var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
	var nonWritable = arguments.length > 4 ? arguments[4] : null;
	var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
	var loose = arguments.length > 6 ? arguments[6] : false;

	/* @type {false | TypedPropertyDescriptor<unknown>} */
	var desc = !!gopd && gopd(obj, property);

	if ($defineProperty) {
		$defineProperty(obj, property, {
			configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
			enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
			value: value,
			writable: nonWritable === null && desc ? desc.writable : !nonWritable
		});
	} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
		// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
		obj[property] = value; // eslint-disable-line no-param-reassign
	} else {
		throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
	}
};


/***/ }),

/***/ 655:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(453);

/** @type {import('.')} */
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true) || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;


/***/ }),

/***/ 237:
/***/ ((module) => {

"use strict";


/** @type {import('./eval')} */
module.exports = EvalError;


/***/ }),

/***/ 383:
/***/ ((module) => {

"use strict";


/** @type {import('.')} */
module.exports = Error;


/***/ }),

/***/ 290:
/***/ ((module) => {

"use strict";


/** @type {import('./range')} */
module.exports = RangeError;


/***/ }),

/***/ 538:
/***/ ((module) => {

"use strict";


/** @type {import('./ref')} */
module.exports = ReferenceError;


/***/ }),

/***/ 68:
/***/ ((module) => {

"use strict";


/** @type {import('./syntax')} */
module.exports = SyntaxError;


/***/ }),

/***/ 675:
/***/ ((module) => {

"use strict";


/** @type {import('./type')} */
module.exports = TypeError;


/***/ }),

/***/ 345:
/***/ ((module) => {

"use strict";


/** @type {import('./uri')} */
module.exports = URIError;


/***/ }),

/***/ 353:
/***/ ((module) => {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 743:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var implementation = __webpack_require__(353);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 453:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var undefined;

var $Error = __webpack_require__(383);
var $EvalError = __webpack_require__(237);
var $RangeError = __webpack_require__(290);
var $ReferenceError = __webpack_require__(538);
var $SyntaxError = __webpack_require__(68);
var $TypeError = __webpack_require__(675);
var $URIError = __webpack_require__(345);

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(39)();
var hasProto = __webpack_require__(24)();

var getProto = Object.getPrototypeOf || (
	hasProto
		? function (x) { return x.__proto__; } // eslint-disable-line no-proto
		: null
);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(743);
var hasOwn = __webpack_require__(957);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 795:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(453);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),

/***/ 592:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var $defineProperty = __webpack_require__(655);

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	return !!$defineProperty;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!$defineProperty) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;


/***/ }),

/***/ 24:
/***/ ((module) => {

"use strict";


var test = {
	__proto__: null,
	foo: {}
};

var $Object = Object;

/** @type {import('.')} */
module.exports = function hasProto() {
	// @ts-expect-error: TS errors on an inherited property for some reason
	return { __proto__: test }.foo === test.foo
		&& !(test instanceof $Object);
};


/***/ }),

/***/ 39:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(333);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 333:
/***/ ((module) => {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 957:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(743);

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);


/***/ }),

/***/ 859:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(634);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (
        (typeof globalThis !== 'undefined' && obj === globalThis)
        || (typeof __webpack_require__.g !== 'undefined' && obj === __webpack_require__.g)
    ) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ 189:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/*!
 * parseurl
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2014-2017 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module dependencies.
 * @private
 */

var url = __webpack_require__(835)
var parse = url.parse
var Url = url.Url

/**
 * Module exports.
 * @public
 */

module.exports = parseurl
module.exports.original = originalurl

/**
 * Parse the `req` url with memoization.
 *
 * @param {ServerRequest} req
 * @return {Object}
 * @public
 */

function parseurl (req) {
  var url = req.url

  if (url === undefined) {
    // URL is undefined
    return undefined
  }

  var parsed = req._parsedUrl

  if (fresh(url, parsed)) {
    // Return cached URL parse
    return parsed
  }

  // Parse the URL
  parsed = fastparse(url)
  parsed._raw = url

  return (req._parsedUrl = parsed)
};

/**
 * Parse the `req` original url with fallback and memoization.
 *
 * @param {ServerRequest} req
 * @return {Object}
 * @public
 */

function originalurl (req) {
  var url = req.originalUrl

  if (typeof url !== 'string') {
    // Fallback
    return parseurl(req)
  }

  var parsed = req._parsedOriginalUrl

  if (fresh(url, parsed)) {
    // Return cached URL parse
    return parsed
  }

  // Parse the URL
  parsed = fastparse(url)
  parsed._raw = url

  return (req._parsedOriginalUrl = parsed)
};

/**
 * Parse the `str` url with fast-path short-cut.
 *
 * @param {string} str
 * @return {Object}
 * @private
 */

function fastparse (str) {
  if (typeof str !== 'string' || str.charCodeAt(0) !== 0x2f /* / */) {
    return parse(str)
  }

  var pathname = str
  var query = null
  var search = null

  // This takes the regexp from https://github.com/joyent/node/pull/7878
  // Which is /^(\/[^?#\s]*)(\?[^#\s]*)?$/
  // And unrolls it into a for loop
  for (var i = 1; i < str.length; i++) {
    switch (str.charCodeAt(i)) {
      case 0x3f: /* ?  */
        if (search === null) {
          pathname = str.substring(0, i)
          query = str.substring(i + 1)
          search = str.substring(i)
        }
        break
      case 0x09: /* \t */
      case 0x0a: /* \n */
      case 0x0c: /* \f */
      case 0x0d: /* \r */
      case 0x20: /*    */
      case 0x23: /* #  */
      case 0xa0:
      case 0xfeff:
        return parse(str)
    }
  }

  var url = Url !== undefined
    ? new Url()
    : {}

  url.path = str
  url.href = str
  url.pathname = pathname

  if (search !== null) {
    url.query = query
    url.search = search
  }

  return url
}

/**
 * Determine if parsed is still fresh for url.
 *
 * @param {string} url
 * @param {object} parsedUrl
 * @return {boolean}
 * @private
 */

function fresh (url, parsedUrl) {
  return typeof parsedUrl === 'object' &&
    parsedUrl !== null &&
    (Url === undefined || parsedUrl instanceof Url) &&
    parsedUrl._raw === url
}


/***/ }),

/***/ 897:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(453);
var define = __webpack_require__(41);
var hasDescriptors = __webpack_require__(592)();
var gOPD = __webpack_require__(795);

var $TypeError = __webpack_require__(675);
var $floor = GetIntrinsic('%Math.floor%');

/** @type {import('.')} */
module.exports = function setFunctionLength(fn, length) {
	if (typeof fn !== 'function') {
		throw new $TypeError('`fn` is not a function');
	}
	if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
		throw new $TypeError('`length` must be a positive 32-bit integer');
	}

	var loose = arguments.length > 2 && !!arguments[2];

	var functionLengthIsConfigurable = true;
	var functionLengthIsWritable = true;
	if ('length' in fn && gOPD) {
		var desc = gOPD(fn, 'length');
		if (desc && !desc.configurable) {
			functionLengthIsConfigurable = false;
		}
		if (desc && !desc.writable) {
			functionLengthIsWritable = false;
		}
	}

	if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
		if (hasDescriptors) {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
		} else {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
		}
	}
	return fn;
};


/***/ }),

/***/ 920:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(453);
var callBound = __webpack_require__(75);
var inspect = __webpack_require__(859);

var $TypeError = __webpack_require__(675);
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/
/** @type {import('.').listGetNode} */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	/** @type {typeof list | NonNullable<(typeof list)['next']>} */
	var prev = list;
	/** @type {(typeof list)['next']} */
	var curr;
	for (; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			// eslint-disable-next-line no-extra-parens
			curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

/** @type {import('.').listGet} */
var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
/** @type {import('.').listSet} */
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = /** @type {import('.').ListNode<typeof value>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
			key: key,
			next: objects.next,
			value: value
		});
	}
};
/** @type {import('.').listHas} */
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

/** @type {import('.')} */
module.exports = function getSideChannel() {
	/** @type {WeakMap<object, unknown>} */ var $wm;
	/** @type {Map<object, unknown>} */ var $m;
	/** @type {import('.').RootNode<unknown>} */ var $o;

	/** @type {import('.').Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};


/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports =  true && exports &&
		!exports.nodeType && exports;
	var freeModule =  true && module &&
		!module.nodeType && module;
	var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}

}(this));


/***/ }),

/***/ 902:
/***/ ((module) => {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ 98:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var stringify = __webpack_require__(207);
var parse = __webpack_require__(969);
var formats = __webpack_require__(902);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ 969:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(176);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        var existing = has.call(obj, key);
        if (existing && options.duplicates === 'combine') {
            obj[key] = utils.combine(obj[key], val);
        } else if (!existing || options.duplicates === 'last') {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = options.allowEmptyArrays && (leaf === '' || (options.strictNullHandling && leaf === null))
                ? []
                : [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== decodedRoot
                && String(index) === decodedRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') {
                obj[decodedRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, check strictDepth option for throw, else just add whatever is left

    if (segment) {
        if (options.strictDepth === true) {
            throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        }
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;

    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
        throw new TypeError('The duplicates option must be either combine, first, or last');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ 207:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var getSideChannel = __webpack_require__(920);
var utils = __webpack_require__(176);
var formats = __webpack_require__(902);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    allowEmptyArrays,
    strictNullHandling,
    skipNulls,
    encodeDotInKeys,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, '%2E') : prefix;

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;

    if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
        return adjustedPrefix + '[]';
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, '%2E') : key;
        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            allowEmptyArrays,
            strictNullHandling,
            skipNulls,
            encodeDotInKeys,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    var arrayFormat;
    if (opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if ('indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = defaults.arrayFormat;
    }

    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.allowEmptyArrays,
            options.strictNullHandling,
            options.skipNulls,
            options.encodeDotInKeys,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ 176:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var formats = __webpack_require__(902);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var limit = 1024;

/* eslint operator-linebreak: [2, "before"] */

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var j = 0; j < string.length; j += limit) {
        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
        var arr = [];

        for (var i = 0; i < segment.length; ++i) {
            var c = segment.charCodeAt(i);
            if (
                c === 0x2D // -
                || c === 0x2E // .
                || c === 0x5F // _
                || c === 0x7E // ~
                || (c >= 0x30 && c <= 0x39) // 0-9
                || (c >= 0x41 && c <= 0x5A) // a-z
                || (c >= 0x61 && c <= 0x7A) // A-Z
                || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }

            if (c < 0x80) {
                arr[arr.length] = hexTable[c];
                continue;
            }

            if (c < 0x800) {
                arr[arr.length] = hexTable[0xC0 | (c >> 6)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = hexTable[0xE0 | (c >> 12)]
                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            i += 1;
            c = 0x10000 + (((c & 0x3FF) << 10) | (segment.charCodeAt(i) & 0x3FF));

            arr[arr.length] = hexTable[0xF0 | (c >> 18)]
                + hexTable[0x80 | ((c >> 12) & 0x3F)]
                + hexTable[0x80 | ((c >> 6) & 0x3F)]
                + hexTable[0x80 | (c & 0x3F)];
        }

        out += arr.join('');
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ 835:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */



var punycode = __webpack_require__(270);

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */
var protocolPattern = /^([a-z0-9.+-]+:)/i,
  portPattern = /:[0-9]*$/,

  // Special case for a simple path URL
  simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/,

  /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */
  delims = [
    '<', '>', '"', '`', ' ', '\r', '\n', '\t'
  ],

  // RFC 2396: characters not allowed for various reasons.
  unwise = [
    '{', '}', '|', '\\', '^', '`'
  ].concat(delims),

  // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
  autoEscape = ['\''].concat(unwise),
  /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */
  nonHostChars = [
    '%', '/', '?', ';', '#'
  ].concat(autoEscape),
  hostEndingChars = [
    '/', '?', '#'
  ],
  hostnameMaxLen = 255,
  hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
  hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
  // protocols that can allow "unsafe" and "unwise" chars.
  unsafeProtocol = {
    javascript: true,
    'javascript:': true
  },
  // protocols that never have a hostname.
  hostlessProtocol = {
    javascript: true,
    'javascript:': true
  },
  // protocols that always contain a // bit.
  slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
  },
  querystring = __webpack_require__(98);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && typeof url === 'object' && url instanceof Url) { return url; }

  var u = new Url();
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function (url, parseQueryString, slashesDenoteHost) {
  if (typeof url !== 'string') {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */
  var queryIndex = url.indexOf('?'),
    splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#',
    uSplit = url.split(splitter),
    slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] && (slashes || (proto && !slashedProtocol[proto]))) {

    /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */

    /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) { hostEnd = hec; }
    }

    /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) { hostEnd = hec; }
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1) { hostEnd = rest.length; }

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */
    this.hostname = this.hostname || '';

    /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */
    var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) { continue; }
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */
  if (!unsafeProtocol[lowerProto]) {

    /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1) { continue; }
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }

  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) { this.pathname = rest; }
  if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  // to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */
  if (typeof obj === 'string') { obj = urlParse(obj); }
  if (!(obj instanceof Url)) { return Url.prototype.format.call(obj); }
  return obj.format();
}

Url.prototype.format = function () {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
    pathname = this.pathname || '',
    hash = this.hash || '',
    host = false,
    query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) {
    query = querystring.stringify(this.query, {
      arrayFormat: 'repeat',
      addQueryPrefix: false
    });
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') { protocol += ':'; }

  /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */
  if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') { pathname = '/' + pathname; }
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') { hash = '#' + hash; }
  if (search && search.charAt(0) !== '?') { search = '?' + search; }

  pathname = pathname.replace(/[?#]/g, function (match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function (relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) { return relative; }
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function (relative) {
  if (typeof relative === 'string') {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol') { result[rkey] = relative[rkey]; }
    }

    // urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
      result.pathname = '/';
      result.path = result.pathname;
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift())) { }
      if (!relative.host) { relative.host = ''; }
      if (!relative.hostname) { relative.hostname = ''; }
      if (relPath[0] !== '') { relPath.unshift(''); }
      if (relPath.length < 2) { relPath.unshift(''); }
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/',
    isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/',
    mustEndAbs = isRelAbs || isSourceAbs || (result.host && relative.pathname),
    removeAllDots = mustEndAbs,
    srcPath = result.pathname && result.pathname.split('/') || [],
    relPath = relative.pathname && relative.pathname.split('/') || [],
    psychotic = result.protocol && !slashedProtocol[result.protocol];

  /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') { srcPath[0] = result.host; } else { srcPath.unshift(result.host); }
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') { relPath[0] = relative.host; } else { relPath.unshift(relative.host); }
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = relative.host || relative.host === '' ? relative.host : result.host;
    result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */
    if (!srcPath) { srcPath = []; }
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (relative.search != null) {
    /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */
    if (psychotic) {
      result.host = srcPath.shift();
      result.hostname = result.host;
      /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */
      var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.hostname = authInHost.shift();
        result.host = result.hostname;
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    // to support http.request
    if (result.pathname !== null || result.search !== null) {
      result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */
    result.pathname = null;
    // to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';

  /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' || (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
    result.host = result.hostname;
    /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */
    var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.hostname = authInHost.shift();
      result.host = result.hostname;
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (srcPath.length > 0) {
    result.pathname = srcPath.join('/');
  } else {
    result.pathname = null;
    result.path = null;
  }

  // to support request.http
  if (result.pathname !== null || result.search !== null) {
    result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function () {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) { this.hostname = host; }
};

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;


/***/ }),

/***/ 512:
/***/ ((module) => {

"use strict";


/* eslint-env browser */

/* eslint-disable no-undef, no-use-before-define, new-cap */
module.exports = function (content, workerConstructor, workerOptions, url) {
  var globalScope = self || window;

  try {
    try {
      var blob;

      try {
        // New API
        blob = new globalScope.Blob([content]);
      } catch (e) {
        // BlobBuilder = Deprecated, but widely implemented
        var BlobBuilder = globalScope.BlobBuilder || globalScope.WebKitBlobBuilder || globalScope.MozBlobBuilder || globalScope.MSBlobBuilder;
        blob = new BlobBuilder();
        blob.append(content);
        blob = blob.getBlob();
      }

      var URL = globalScope.URL || globalScope.webkitURL;
      var objectURL = URL.createObjectURL(blob);
      var worker = new globalScope[workerConstructor](objectURL, workerOptions);
      URL.revokeObjectURL(objectURL);
      return worker;
    } catch (e) {
      return new globalScope[workerConstructor]("data:application/javascript,".concat(encodeURIComponent(content)), workerOptions);
    }
  } catch (e) {
    if (!url) {
      throw Error("Inline worker is not supported");
    }

    return new globalScope[workerConstructor](url, workerOptions);
  }
};

/***/ }),

/***/ 634:
/***/ (() => {

/* (ignored) */

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "";
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(813);
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});